/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type UpdateAccountInput = {
  id: string;
  name?: string | null;
  status?: AccountStatus | null;
  note?: string | null;
  acquirer?: Acquirer | null;
  adminEmail?: string | null;
  riskScore?: number | null;
  timezone?: string | null;
  language?: string | null;
  partner?: Partner | null;
  paymentMethods?: AccountPaymentMethodsInput | null;
  defaultCurrency?: Currencies | null;
  defaultTransactionType?: TransactionTypes | null;
  business?: BusinessDataInput | null;
  representatives?: Array<RepresentativeInput | null> | null;
  publicBusinessDetails?: AccountPublicBusinessDetailsInput | null;
  branding?: AccountBrandingInput | null;
  iban?: string | null;
  dynamicBilling?: boolean | null;
  customDomain?: string | null;
  payoutTerms?: AccountPayoutTermsInput | null;
  fees?: AccountFeesInput | null;
  referralCode?: string | null;
  promoCode?: string | null;
  billingPlan?: BillingPlans | null;
  notifications?: AccountNotificationsInput | null;
  reason?: string | null;
  billingVatPercent?: number | null;
  allowCreateApiKey?: boolean | null;
  masterAccountId?: string | null;
  reviewConfirmed?: boolean | null;
};

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  REJECTED = 'REJECTED',
  DELETED = 'DELETED',
  SUSPENDED = 'SUSPENDED',
  PENDING_CONTRACT = 'PENDING_CONTRACT',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED'
}

export enum Acquirer {
  CUSTOM = 'CUSTOM',
  ADYEN = 'ADYEN',
  STRIPE = 'STRIPE',
  MONEI_X = 'MONEI_X',
  COFIDIS = 'COFIDIS',
  PAYPAL = 'PAYPAL',
  PAYCOMET = 'PAYCOMET',
  ABANCA = 'ABANCA',
  BANCAMARCH = 'BANCAMARCH',
  BANKIA = 'BANKIA',
  BANKINTER = 'BANKINTER',
  BBVA = 'BBVA',
  CAJALABORAL = 'CAJALABORAL',
  CAJAMAR = 'CAJAMAR',
  CAJARURAL = 'CAJARURAL',
  CAJASUR = 'CAJASUR',
  COMERCIAGLOBALPAY = 'COMERCIAGLOBALPAY',
  CREDITANDORRA = 'CREDITANDORRA',
  KUTXABANK = 'KUTXABANK',
  SABADELL = 'SABADELL',
  SANTANDER = 'SANTANDER',
  UNICAJA = 'UNICAJA',
  DEUTSCHE_BANK = 'DEUTSCHE_BANK'
}

export enum Partner {
  SHOPIFY = 'SHOPIFY',
  V1 = 'V1',
  ACTIVE_MERCHANT = 'ACTIVE_MERCHANT'
}

export type AccountPaymentMethodsInput = {
  CREDITCARD?: AccountPaymentMethodsCreditCardInput | null;
  BIZUM?: AccountPaymentMethodsBizumInput | null;
};

export type AccountPaymentMethodsCreditCardInput = {
  enabled?: boolean | null;
  allowPaymentDetails?: boolean | null;
  preauthorization?: boolean | null;
};

export type AccountPaymentMethodsBizumInput = {
  enabled?: boolean | null;
};

export enum Currencies {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  JPY = 'JPY',
  CHF = 'CHF'
}

export enum TransactionTypes {
  AUTH = 'AUTH',
  SALE = 'SALE',
  REFUND = 'REFUND',
  CAPTURE = 'CAPTURE',
  CANCEL = 'CANCEL',
  VOID = 'VOID'
}

export type BusinessDataInput = {
  country?: string | null;
  legalForm?: LegalForm | null;
  legalName?: string | null;
  companyName?: string | null;
  address?: AddressInput | null;
  documentNumber?: string | null;
  email?: string | null;
  phone?: string | null;
  website?: string | null;
  monthlyVolume?: string | null;
  industry?: Industries | null;
  mcc?: string | null;
  servicesDescription?: string | null;
  status?: BusinessStatus | null;
  creationDate?: string | null;
};

export enum LegalForm {
  INDIVIDUAL = 'INDIVIDUAL',
  FREELANCE = 'FREELANCE',
  COMPANY = 'COMPANY'
}

export type AddressInput = {
  city?: string | null;
  country?: string | null;
  line1?: string | null;
  line2?: string | null;
  zip?: string | null;
  state?: string | null;
};

export enum Industries {
  ECOMMERCE = 'ECOMMERCE'
}

export enum BusinessStatus {
  active = 'active',
  inactive = 'inactive',
  dissolved = 'dissolved',
  renamed = 'renamed',
  transformed = 'transformed',
  resubmission_requested = 'resubmission_requested'
}

export type RepresentativeInput = {
  firstName?: string | null;
  lastName?: string | null;
  address?: AddressInput | null;
  email?: string | null;
  phone?: string | null;
  dateOfBirth?: string | null;
  yearOfBirth?: string | null;
  documentNumber?: string | null;
  stocksPercentage?: number | null;
  status?: IdVerificationStatus | null;
  nationality?: string | null;
  citizenship?: string | null;
  interventionType?: Array<InterventionType> | null;
  registeredAt?: string | null;
  deletedAt?: string | null;
};

export enum IdVerificationStatus {
  submitted = 'submitted',
  approved = 'approved',
  resubmission_requested = 'resubmission_requested',
  declined = 'declined',
  expired = 'expired',
  abandoned = 'abandoned'
}

export enum InterventionType {
  TIT = 'TIT',
  TRE = 'TRE',
  AUT = 'AUT',
  REP = 'REP',
  OTR = 'OTR'
}

export type AccountPublicBusinessDetailsInput = {
  companyName?: string | null;
  website?: string | null;
  phone?: string | null;
  address?: AddressInput | null;
  supportWebsite?: string | null;
  supportEmail?: string | null;
  supportPhone?: string | null;
};

export type AccountBrandingInput = {
  accentColor?: string | null;
  bgColor?: string | null;
  logoUrl?: string | null;
  iconUrl?: string | null;
};

export type AccountPayoutTermsInput = {
  iban?: string | null;
  firstPeriod?: number | null;
  period?: number | null;
  reservePercent?: number | null;
  suspended?: boolean | null;
  releaseReserve?: boolean | null;
};

export type AccountFeesInput = {
  trxFee?: number | null;
  trxFlatFee?: number | null;
  highRiskFee?: number | null;
  dailyPlatformFee?: number | null;
  dailyExtraSeatsFee?: number | null;
  extra?: Array<AccountExtraFeeInput> | null;
  steps?: Array<AccountStepsInput | null> | null;
};

export type AccountExtraFeeInput = {
  name?: string | null;
  amount?: number | null;
  type?: AccountExtraFeeType | null;
  region?: AccountExtraFeeRegion | null;
  masterAccountFee?: boolean | null;
};

export enum AccountExtraFeeType {
  daily = 'daily',
  percent = 'percent'
}

export enum AccountExtraFeeRegion {
  domestic = 'domestic',
  non_domestic = 'non_domestic',
  all = 'all'
}

export type AccountStepsInput = {
  from?: number | null;
  trxFee?: number | null;
  trxFlatFee?: number | null;
  bizumTrxFee?: number | null;
  bizumTrxFlatFee?: number | null;
  multibancoTrxFee?: number | null;
  multibancoTrxFlatFee?: number | null;
};

export enum BillingPlans {
  MONEI_PLUS = 'MONEI_PLUS',
  MONEI_POS = 'MONEI_POS',
  MONEI_X = 'MONEI_X'
}

export type AccountNotificationsInput = {
  emailCustomerOnRefund?: boolean | null;
  emailCustomerOnSuccess?: boolean | null;
  emailAdminOnSuccess?: boolean | null;
};

export type Account = {
  __typename: 'Account';
  id: string;
  name?: string | null;
  status: AccountStatus;
  reason?: string | null;
  note?: string | null;
  partner?: Partner | null;
  acquirer?: Acquirer | null;
  adminEmail?: string | null;
  riskScore?: number | null;
  timezone?: string | null;
  language?: string | null;
  paymentMethods?: AccountPaymentMethods | null;
  defaultCurrency?: Currencies | null;
  defaultTransactionType?: TransactionTypes | null;
  business?: BusinessData | null;
  representatives?: Array<Representative> | null;
  publicBusinessDetails?: AccountPublicBusinessDetails | null;
  branding?: AccountBranding | null;
  payoutTerms?: AccountPayoutTerms | null;
  iban?: string | null;
  fees?: AccountFees | null;
  test?: boolean | null;
  secret?: string | null;
  apiKey?: string | null;
  customDomain?: string | null;
  dynamicBilling?: boolean | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  deletedAt?: string | null;
  approvedAt?: string | null;
  rejectedAt?: string | null;
  activatedAt?: string | null;
  approvalRequestedAt?: string | null;
  suspendedAt?: string | null;
  dataUpdatedAt?: string | null;
  tokenizationMethods?: AccountTokenizationMethods | null;
  referralCode?: string | null;
  promoCode?: string | null;
  billingPlan?: BillingPlans | null;
  notifications?: AccountNotifications | null;
  contract?: AccountContract | null;
  billingVatPercent?: number | null;
  allowCreateApiKey?: boolean | null;
  masterAccountId?: string | null;
  reviewConfirmed?: boolean | null;
  churned?: boolean | null;
};

export type AccountPaymentMethods = {
  __typename: 'AccountPaymentMethods';
  CREDITCARD?: AccountPaymentMethodsCreditCard | null;
  BIZUM?: AccountPaymentMethodsBizum | null;
};

export type AccountPaymentMethodsCreditCard = {
  __typename: 'AccountPaymentMethodsCreditCard';
  enabled?: boolean | null;
  allowPaymentDetails?: boolean | null;
  preauthorization?: boolean | null;
};

export type AccountPaymentMethodsBizum = {
  __typename: 'AccountPaymentMethodsBizum';
  enabled?: boolean | null;
};

export type BusinessData = {
  __typename: 'BusinessData';
  country?: string | null;
  legalForm?: LegalForm | null;
  legalName?: string | null;
  companyName?: string | null;
  address?: Address | null;
  documentNumber?: string | null;
  email?: string | null;
  phone?: string | null;
  website?: string | null;
  monthlyVolume?: number | null;
  confirmWebsite?: boolean | null;
  industry?: Industries | null;
  mcc?: string | null;
  servicesDescription?: string | null;
  status?: BusinessStatus | null;
  confirmServicesDescription?: boolean | null;
  legalAddress?: string | null;
  legalDescription?: string | null;
  creationDate?: string | null;
  lastUpdateDate?: string | null;
  startActivityDate?: string | null;
  registryRecords?: Array<RegistryRecord> | null;
  positions?: Array<BusinessPosition> | null;
  capital?: string | null;
  previousNames?: Array<string | null> | null;
  verificationAttempts?: number | null;
  riskLabels?: Array<RiskLabel> | null;
};

export type Address = {
  __typename: 'Address';
  city?: string | null;
  country?: string | null;
  line1?: string | null;
  line2?: string | null;
  zip?: string | null;
  state?: string | null;
};

export type RegistryRecord = {
  __typename: 'RegistryRecord';
  name?: string | null;
  url?: string | null;
  province?: string | null;
  date?: string | null;
};

export type BusinessPosition = {
  __typename: 'BusinessPosition';
  fromDate?: string | null;
  role?: string | null;
  name?: string | null;
};

export type RiskLabel = {
  __typename: 'RiskLabel';
  label?: string | null;
  category?: string | null;
};

export type Representative = {
  __typename: 'Representative';
  firstName?: string | null;
  lastName?: string | null;
  address?: Address | null;
  email?: string | null;
  phone?: string | null;
  documentNumber?: string | null;
  stocksPercentage?: number | null;
  gender?: Gender | null;
  dateOfBirth?: string | null;
  yearOfBirth?: string | null;
  placeOfBirth?: string | null;
  document?: IdDocument | null;
  idSession?: string | null;
  idSessionUrl?: string | null;
  interventionType?: Array<InterventionType> | null;
  status?: IdVerificationStatus | null;
  statusMessage?: string | null;
  statusCode?: number | null;
  riskLabels?: Array<RiskLabel> | null;
  hasNoPublicActivity?: boolean | null;
  nationality?: string | null;
  citizenship?: string | null;
  registeredAt?: string | null;
  deletedAt?: string | null;
};

export enum Gender {
  M = 'M',
  F = 'F'
}

export type IdDocument = {
  __typename: 'IdDocument';
  type?: string | null;
  number?: string | null;
  country?: string | null;
  validFrom?: string | null;
  validUntil?: string | null;
};

export type AccountPublicBusinessDetails = {
  __typename: 'AccountPublicBusinessDetails';
  companyName?: string | null;
  website?: string | null;
  phone?: string | null;
  address?: Address | null;
  supportWebsite?: string | null;
  supportEmail?: string | null;
  supportPhone?: string | null;
};

export type AccountBranding = {
  __typename: 'AccountBranding';
  accentColor?: string | null;
  bgColor?: string | null;
  logoUrl?: string | null;
  iconUrl?: string | null;
};

export type AccountPayoutTerms = {
  __typename: 'AccountPayoutTerms';
  iban?: string | null;
  firstPeriod?: number | null;
  period?: number | null;
  reservePercent?: number | null;
  suspended?: boolean | null;
  releaseReserve?: boolean | null;
};

export type AccountFees = {
  __typename: 'AccountFees';
  trxFee?: number | null;
  trxFlatFee?: number | null;
  highRiskFee?: number | null;
  dailyPlatformFee?: number | null;
  dailyExtraSeatsFee?: number | null;
  extra?: Array<AccountExtraFee> | null;
  steps?: Array<AccountSteps> | null;
};

export type AccountExtraFee = {
  __typename: 'AccountExtraFee';
  name: string;
  amount: number;
  type: AccountExtraFeeType;
  region?: AccountExtraFeeRegion | null;
  masterAccountFee?: boolean | null;
};

export type AccountSteps = {
  __typename: 'AccountSteps';
  from: number;
  trxFee: number;
  trxFlatFee: number;
  bizumTrxFee?: number | null;
  bizumTrxFlatFee?: number | null;
  multibancoTrxFee?: number | null;
  multibancoTrxFlatFee?: number | null;
};

export type AccountTokenizationMethods = {
  __typename: 'AccountTokenizationMethods';
  googlePay?: AccountTokenizationMethodsItem | null;
  applePay?: AccountTokenizationMethodsItem | null;
  clickToPay?: AccountTokenizationMethodsClickToPayItem | null;
};

export type AccountTokenizationMethodsItem = {
  __typename: 'AccountTokenizationMethodsItem';
  enabled?: boolean | null;
};

export type AccountTokenizationMethodsClickToPayItem = {
  __typename: 'AccountTokenizationMethodsClickToPayItem';
  enabled?: boolean | null;
  dpaId?: string | null;
};

export type AccountNotifications = {
  __typename: 'AccountNotifications';
  emailCustomerOnRefund?: boolean | null;
  emailCustomerOnSuccess?: boolean | null;
  emailAdminOnSuccess?: boolean | null;
};

export type AccountContract = {
  __typename: 'AccountContract';
  envelopeId: string;
  status: ContractStatus;
  path?: string | null;
  signedDate?: string | null;
};

export enum ContractStatus {
  completed = 'completed',
  created = 'created',
  declined = 'declined',
  delivered = 'delivered',
  sent = 'sent',
  signed = 'signed',
  voided = 'voided'
}

export type UpdateDocumentInput = {
  accountId: string;
  id: string;
  note?: string | null;
  status?: DocumentStatus | null;
  statusCode?: string | null;
  internal?: boolean | null;
  name?: string | null;
};

export enum DocumentStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED'
}

export type Document = {
  __typename: 'Document';
  id: string;
  accountId: string;
  type: DocumentType;
  status: DocumentStatus;
  statusCode?: string | null;
  statusMessage?: string | null;
  contentType?: string | null;
  createdAt: string;
  updatedAt?: string | null;
  name?: string | null;
  note?: string | null;
  internal?: boolean | null;
  traceDetails?: TraceDetails | null;
  metadata?: Array<DocumentMetadataItem> | null;
};

export enum DocumentType {
  CENSUS_CERT = 'CENSUS_CERT',
  BANK_OWNERSHIP_CERT = 'BANK_OWNERSHIP_CERT',
  CONTRACT = 'CONTRACT',
  PIBISI_REPORT = 'PIBISI_REPORT',
  VERIFF_REPORT = 'VERIFF_REPORT',
  PASSPORT = 'PASSPORT',
  ID_CARD = 'ID_CARD',
  COMPANY_TAX_ID = 'COMPANY_TAX_ID',
  RESIDENCE_PERMIT = 'RESIDENCE_PERMIT',
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  DEED_OF_INCORPORATION = 'DEED_OF_INCORPORATION',
  BENEFICIAL_OWNERSHIP_REPORT = 'BENEFICIAL_OWNERSHIP_REPORT',
  DEED_OF_COMPANY_REPRESENTATIVE = 'DEED_OF_COMPANY_REPRESENTATIVE',
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
  OTHER = 'OTHER'
}

export type TraceDetails = {
  __typename: 'TraceDetails';
  ip?: string | null;
  userAgent?: string | null;
  countryCode?: string | null;
  lang?: string | null;
  deviceType?: DeviceType | null;
  deviceModel?: string | null;
  browser?: string | null;
  browserVersion?: string | null;
  browserAccept?: string | null;
  os?: string | null;
  osVersion?: string | null;
  source?: string | null;
  sourceVersion?: string | null;
  userId?: string | null;
  userEmail?: string | null;
  userName?: string | null;
};

export enum DeviceType {
  desktop = 'desktop',
  mobile = 'mobile',
  smartTV = 'smartTV',
  tablet = 'tablet'
}

export type DocumentMetadataItem = {
  __typename: 'DocumentMetadataItem';
  key: string;
  value?: string | null;
};

export enum Processor {
  ADYEN = 'ADYEN',
  STRIPE = 'STRIPE',
  REDSYS = 'REDSYS',
  MONEI_REDSYS = 'MONEI_REDSYS',
  MONEIX_F = 'MONEIX_F',
  MONEIX_G = 'MONEIX_G',
  MONEIX_P = 'MONEIX_P',
  MONEI_X = 'MONEI_X',
  PAYPAL = 'PAYPAL',
  COFIDIS = 'COFIDIS'
}

export type SuccessResult = {
  __typename: 'SuccessResult';
  success: boolean;
};

export type CreateProviderInput = {
  accountId: string;
  processor?: Processor | null;
  enabled?: boolean | null;
  test?: boolean | null;
  acquirer: Acquirer;
  paymentMethod?: PaymentMethods | null;
  nativeHostedPayment?: boolean | null;
  metadata?: Array<MetadataItemInput> | null;
  rules?: ProviderRulesInput | null;
};

export enum PaymentMethods {
  card = 'card',
  bizum = 'bizum',
  paypal = 'paypal',
  cofidis = 'cofidis',
  cofidisLoan = 'cofidisLoan',
  googlePay = 'googlePay',
  applePay = 'applePay',
  clickToPay = 'clickToPay',
  mbway = 'mbway',
  multibanco = 'multibanco',
  iDeal = 'iDeal',
  bancontact = 'bancontact',
  sofort = 'sofort',
  trustly = 'trustly',
  sepa = 'sepa',
  klarna = 'klarna',
  giropay = 'giropay',
  alipay = 'alipay',
  eps = 'eps'
}

export type MetadataItemInput = {
  key: string;
  value?: string | null;
};

export type ProviderRulesInput = {
  minAmount?: number | null;
  maxAmount?: number | null;
  shopNameLike?: string | null;
  descriptionLike?: string | null;
};

export type Provider = {
  __typename: 'Provider';
  id: string;
  processor?: Processor | null;
  enabled?: boolean | null;
  test?: boolean | null;
  paymentMethod?: PaymentMethods | null;
  acquirer?: Acquirer | null;
  configurable?: boolean | null;
  metadata?: Array<MetadataItem> | null;
  nativeHostedPayment?: boolean | null;
  rules?: ProviderRules | null;
};

export type MetadataItem = {
  __typename: 'MetadataItem';
  key: string;
  value?: string | null;
  type: MetadataItemType;
  label?: string | null;
  possibleValues?: Array<string> | null;
  regex?: string | null;
  secret?: boolean | null;
  required?: boolean | null;
  default?: string | null;
  example?: string | null;
  internal?: boolean | null;
};

export enum MetadataItemType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  STRING_ARRAY = 'STRING_ARRAY',
  NUMBER_ARRAY = 'NUMBER_ARRAY'
}

export type ProviderRules = {
  __typename: 'ProviderRules';
  minAmount?: number | null;
  maxAmount?: number | null;
  shopNameLike?: string | null;
  descriptionLike?: string | null;
};

export type UpdateProviderInput = {
  id: string;
  enabled?: boolean | null;
  test?: boolean | null;
  acquirer?: Acquirer | null;
  nativeHostedPayment?: boolean | null;
  metadata?: Array<MetadataItemInput> | null;
  rules?: ProviderRulesInput | null;
};

export type CreateStoreInput = {
  accountId: string;
  name?: string | null;
};

export type Store = {
  __typename: 'Store';
  id: string;
  accountId: string;
  name?: string | null;
};

export type UpdateStoreInput = {
  id: string;
  name?: string | null;
};

export type CreatePointOfSaleInput = {
  accountId: string;
  storeId: string;
  name?: string | null;
  manualAmount?: boolean | null;
};

export type PointOfSale = {
  __typename: 'PointOfSale';
  id: string;
  accountId: string;
  storeId: string;
  number: number;
  name?: string | null;
  currentPaymentId?: string | null;
  manualAmount?: boolean | null;
};

export type UpdatePointOfSaleInput = {
  id: string;
  name?: string | null;
  manualAmount?: boolean | null;
};

export type CreateCodeInput = {
  accountId: string;
  type: CodeTypes;
  enabled?: boolean | null;
  metadata?: Array<MetadataItemInput> | null;
};

export enum CodeTypes {
  POINT_OF_SALE = 'POINT_OF_SALE'
}

export type Code = {
  __typename: 'Code';
  id: string;
  type: CodeTypes;
  enabled?: boolean | null;
  metadata?: Array<MetadataItem> | null;
};

export type UpdateCodeInput = {
  id: string;
  enabled?: boolean | null;
  metadata?: Array<MetadataItemInput> | null;
};

export type CreateAuthorizedUserInput = {
  accountId: string;
  userEmail: string;
  accessLevel?: AuthorizedUserAccessLevel | null;
  storeId?: string | null;
};

export enum AuthorizedUserAccessLevel {
  READ_ACCESS = 'READ_ACCESS',
  WRITE_ACCESS = 'WRITE_ACCESS',
  ADMIN_ACCESS = 'ADMIN_ACCESS'
}

export type AuthorizedUser = {
  __typename: 'AuthorizedUser';
  accountId?: string | null;
  userEmail: string;
  id?: string | null;
  accessLevel: AuthorizedUserAccessLevel;
  storeId?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type UpdateAuthorizedUserInput = {
  accountId: string;
  userEmail: string;
  accessLevel?: AuthorizedUserAccessLevel | null;
  storeId?: string | null;
};

export type AccountInvoiceInput = {
  from: number;
  to: number;
  accountId: string;
  timezone?: string | null;
};

export type AccountInvoice = {
  __typename: 'AccountInvoice';
  accountId: string;
  number: string;
  period: AccountInvoicePeriod;
  currency: string;
  amount: number;
  tax: number;
  totalAmount: number;
  lineItems: Array<AccountInvoiceLineItem>;
  createdAt: number;
  business?: InvoiceBusinessData | null;
};

export type AccountInvoicePeriod = {
  __typename: 'AccountInvoicePeriod';
  from?: number | null;
  to?: number | null;
};

export type AccountInvoiceLineItem = {
  __typename: 'AccountInvoiceLineItem';
  name: string;
  quantity: number;
  unitAmount: number;
  unitType: InvoiceLineItemUnitType;
  currency: string;
  amount: number;
};

export enum InvoiceLineItemUnitType {
  money = 'money',
  percent = 'percent'
}

export type InvoiceBusinessData = {
  __typename: 'InvoiceBusinessData';
  legalName?: string | null;
  iban?: string | null;
  documentNumber?: string | null;
  mandateSignatureTimestamp?: string | null;
};

export type ImpersonateInput = {
  adminEmail: string;
  userEmail: string;
  accountId?: string | null;
};

export type SearchableChargeFilterInput = {
  id?: SearchableIDFilterInput | null;
  checkoutId?: SearchableIDFilterInput | null;
  accountId?: SearchableIDFilterInput | null;
  providerReferenceId?: SearchableStringFilterInput | null;
  createdAt?: SearchableIntFilterInput | null;
  updatedAt?: SearchableIntFilterInput | null;
  amount?: SearchableIntFilterInput | null;
  authorizationCode?: SearchableStringFilterInput | null;
  acquirer?: SearchableStringFilterInput | null;
  processor?: SearchableStringFilterInput | null;
  currency?: SearchableStringFilterInput | null;
  description?: SearchableStringFilterInput | null;
  orderId?: SearchableStringFilterInput | null;
  storeId?: SearchableStringFilterInput | null;
  pointOfSaleId?: SearchableStringFilterInput | null;
  sequenceId?: SearchableStringFilterInput | null;
  subscriptionId?: SearchableStringFilterInput | null;
  refundedAmount?: SearchableIntFilterInput | null;
  status?: SearchableStringFilterInput | null;
  statusCode?: SearchableStringFilterInput | null;
  statusMessage?: SearchableStringFilterInput | null;
  customerEmail?: SearchableStringFilterInput | null;
  customerName?: SearchableStringFilterInput | null;
  customerPhone?: SearchableStringFilterInput | null;
  paymentMethodMethod?: SearchableStringFilterInput | null;
  paymentMethodCardBrand?: SearchableStringFilterInput | null;
  paymentMethodCardLast4?: SearchableStringFilterInput | null;
  paymentMethodCardType?: SearchableStringFilterInput | null;
  paymentMethodBizumIntegrationType?: SearchableStringFilterInput | null;
  paymentMethodCardThreeDSecure?: SearchableBooleanFilterInput | null;
  paymentMethodCardThreeDSecureVersion?: SearchableStringFilterInput | null;
  paymentMethodCardThreeDSecureFlow?: SearchableStringFilterInput | null;
  paymentMethodCardTokenizationMethod?: SearchableStringFilterInput | null;
  shopCountry?: SearchableStringFilterInput | null;
  shopName?: SearchableStringFilterInput | null;
  sessionIp?: SearchableStringFilterInput | null;
  sessionCountry?: SearchableStringFilterInput | null;
  traceDetailsSource?: SearchableStringFilterInput | null;
  masterAccountId?: SearchableStringFilterInput | null;
  billingPlan?: SearchableStringFilterInput | null;
  and?: Array<SearchableChargeFilterInput | null> | null;
  or?: Array<SearchableChargeFilterInput | null> | null;
  not?: SearchableChargeFilterInput | null;
};

export type SearchableIDFilterInput = {
  ne?: string | null;
  eq?: string | null;
  match?: string | null;
  matchPhrase?: string | null;
  matchPhrasePrefix?: string | null;
  exists?: boolean | null;
  wildcard?: string | null;
  regexp?: string | null;
};

export type SearchableStringFilterInput = {
  ne?: string | null;
  eq?: string | null;
  match?: string | null;
  matchPhrase?: string | null;
  matchPhrasePrefix?: string | null;
  exists?: boolean | null;
  wildcard?: string | null;
  regexp?: string | null;
};

export type SearchableIntFilterInput = {
  ne?: number | null;
  gt?: number | null;
  lt?: number | null;
  gte?: number | null;
  lte?: number | null;
  eq?: number | null;
  range?: Array<number | null> | null;
};

export type SearchableBooleanFilterInput = {
  eq?: boolean | null;
  ne?: boolean | null;
};

export type DownloadFile = {
  __typename: 'DownloadFile';
  downloadUrl: string;
  expiresAt: number;
};

export type User = {
  __typename: 'User';
  id: string;
  email: string;
  status: UserStatus;
  enabled: boolean;
  accountId?: string | null;
  testAccountId?: string | null;
  createdAt: string;
  locale?: string | null;
  referralCode?: string | null;
  promoCode?: string | null;
  emailVerified?: boolean | null;
  phoneNumber?: string | null;
  phoneNumberVerified?: boolean | null;
  smsMfaEnabled?: boolean | null;
};

export enum UserStatus {
  UNCONFIRMED = 'UNCONFIRMED',
  CONFIRMED = 'CONFIRMED',
  ARCHIVED = 'ARCHIVED',
  COMPROMISED = 'COMPROMISED',
  UNKNOWN = 'UNKNOWN',
  RESET_REQUIRED = 'RESET_REQUIRED',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER'
}

export type GenerateSettlementReportInput = {
  accountId: string;
  file: S3ObjectInput;
  timezone?: string | null;
  columns?: ColumnsInput | null;
};

export type S3ObjectInput = {
  bucket: string;
  region: string;
  key?: string | null;
};

export type ColumnsInput = {
  amount?: string | null;
  commission?: string | null;
  authorizationCode?: string | null;
};

export enum TokenizationMethods {
  googlePay = 'googlePay',
  applePay = 'applePay',
  clickToPay = 'clickToPay'
}

export type CreateSubscriptionInput = {
  amount: number;
  currency?: Currencies | null;
  description?: string | null;
  customer?: CustomerInput | null;
  billingDetails?: ContactDetailsInput | null;
  shippingDetails?: ContactDetailsInput | null;
  interval: Interval;
  intervalCount: number;
  trialPeriodDays?: number | null;
  trialPeriodEnd?: number | null;
  callbackUrl?: string | null;
  paymentCallbackUrl?: string | null;
  storeId?: string | null;
  masterAccountId?: string | null;
  accountId: string;
};

export type CustomerInput = {
  email?: string | null;
  name?: string | null;
  phone?: string | null;
};

export type ContactDetailsInput = {
  email?: string | null;
  name?: string | null;
  company?: string | null;
  phone?: string | null;
  address?: AddressInput | null;
};

export enum Interval {
  hour = 'hour',
  day = 'day',
  week = 'week',
  month = 'month',
  quarter = 'quarter',
  year = 'year'
}

export type Subscription = {
  __typename: 'Subscription';
  id: string;
  accountId: string;
  livemode: boolean;
  amount: number;
  currency?: Currencies | null;
  description?: string | null;
  planVariantId?: string | null;
  productId?: string | null;
  cancelAtPeriodEnd?: boolean | null;
  pauseIntervalCount?: number | null;
  pauseAtPeriodEnd?: boolean | null;
  currentPeriodStart?: number | null;
  currentPeriodEnd?: number | null;
  trialPeriodDays?: number | null;
  trialPeriodEnd?: number | null;
  customerId?: string | null;
  customer?: Customer | null;
  billingDetails?: ContactDetails | null;
  shippingDetails?: ContactDetails | null;
  defaultTokenId?: string | null;
  sequenceId?: string | null;
  lastInvoiceId?: string | null;
  lastOrderId?: string | null;
  lastPayment?: LastPayment | null;
  paymentMethod?: PaymentMethod | null;
  nextPaymentAt?: number | null;
  createdAt?: number | null;
  updatedAt?: number | null;
  interval: Interval;
  intervalCount: number;
  retryCount?: number | null;
  metadata?: Array<MetadataItem | null> | null;
  status: SubscriptionStatus;
  traceDetails?: TraceDetails | null;
  callbackUrl?: string | null;
  paymentCallbackUrl?: string | null;
  storeId?: string | null;
  masterAccountId?: string | null;
};

export type Customer = {
  __typename: 'Customer';
  email?: string | null;
  name?: string | null;
  phone?: string | null;
};

export type ContactDetails = {
  __typename: 'ContactDetails';
  email?: string | null;
  name?: string | null;
  company?: string | null;
  phone?: string | null;
  address?: Address | null;
};

export type LastPayment = {
  __typename: 'LastPayment';
  id: string;
  status: PaymentStatus;
  statusMessage?: string | null;
  statusCode?: string | null;
};

export enum PaymentStatus {
  SUCCEEDED = 'SUCCEEDED',
  PENDING = 'PENDING',
  PENDING_PROCESSING = 'PENDING_PROCESSING',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  REFUNDED = 'REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  AUTHORIZED = 'AUTHORIZED',
  EXPIRED = 'EXPIRED'
}

export type PaymentMethod = {
  __typename: 'PaymentMethod';
  method?: PaymentMethods | null;
  bizum?: PaymentMethodBizum | null;
  card?: PaymentMethodCard | null;
  cofidis?: PaymentMethodCofidis | null;
  cofidisLoan?: PaymentMethodCofidisLoan | null;
  mbway?: PaymentMethodMBWay | null;
  paypal?: PaymentMethodPaypal | null;
  sepa?: PaymentMethodSepa | null;
  trustly?: PaymentMethodTrustly | null;
  klarna?: PaymentMethodKlarna | null;
};

export type PaymentMethodBizum = {
  __typename: 'PaymentMethodBizum';
  phoneNumber?: string | null;
  integrationType?: string | null;
};

export type PaymentMethodCard = {
  __typename: 'PaymentMethodCard';
  brand?: CardBrand | null;
  country?: string | null;
  type?: CardType | null;
  threeDSecure?: boolean | null;
  threeDSecureVersion?: string | null;
  threeDSecureFlow?: ThreeDSecureFlow | null;
  last4?: string | null;
  cardholderName?: string | null;
  cardholderEmail?: string | null;
  expiration?: number | null;
  bank?: string | null;
  tokenizationMethod?: TokenizationMethods | null;
  srcCorrelationId?: string | null;
  srciTransactionId?: string | null;
  srcDpaId?: string | null;
};

export enum CardBrand {
  visa = 'visa',
  mastercard = 'mastercard',
  diners = 'diners',
  unknown = 'unknown',
  amex = 'amex',
  jcb = 'jcb',
  unionpay = 'unionpay',
  discover = 'discover'
}

export enum CardType {
  debit = 'debit',
  credit = 'credit'
}

export enum ThreeDSecureFlow {
  CHALLENGE = 'CHALLENGE',
  FRICTIONLESS = 'FRICTIONLESS',
  FRICTIONLESS_CHALLENGE = 'FRICTIONLESS_CHALLENGE',
  DIRECT = 'DIRECT'
}

export type PaymentMethodCofidis = {
  __typename: 'PaymentMethodCofidis';
  orderId?: string | null;
};

export type PaymentMethodCofidisLoan = {
  __typename: 'PaymentMethodCofidisLoan';
  orderId?: string | null;
};

export type PaymentMethodMBWay = {
  __typename: 'PaymentMethodMBWay';
  phoneNumber?: string | null;
};

export type PaymentMethodPaypal = {
  __typename: 'PaymentMethodPaypal';
  orderId?: string | null;
  payerId?: string | null;
  email?: string | null;
  name?: string | null;
};

export type PaymentMethodSepa = {
  __typename: 'PaymentMethodSepa';
  accountholderAddress?: Address | null;
  accountholderEmail?: string | null;
  accountholderName?: string | null;
  countryCode?: string | null;
  bankAddress?: string | null;
  bankCode?: string | null;
  bankName?: string | null;
  bic?: string | null;
  last4?: string | null;
};

export type PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly';
  customerId?: string | null;
};

export type PaymentMethodKlarna = {
  __typename: 'PaymentMethodKlarna';
  billingCategory?: BillingCategoryKlarna | null;
  authPaymentMethod?: AuthPaymentMethodKlarna | null;
};

export enum BillingCategoryKlarna {
  PAY_LATER = 'PAY_LATER',
  PAY_NOW = 'PAY_NOW',
  SLICE_IT = 'SLICE_IT',
  SLICE_IT_BY_CARD = 'SLICE_IT_BY_CARD'
}

export enum AuthPaymentMethodKlarna {
  invoice = 'invoice',
  fixed_amount = 'fixed_amount',
  pix = 'pix',
  base_account = 'base_account',
  deferred_interest = 'deferred_interest',
  direct_debit = 'direct_debit',
  direct_bank_transfer = 'direct_bank_transfer',
  b2b_invoice = 'b2b_invoice',
  card = 'card',
  slice_it_by_card = 'slice_it_by_card'
}

export enum SubscriptionStatus {
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
  TRIALING = 'TRIALING',
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
  CANCELED = 'CANCELED'
}

export type ActivateSubscriptionInput = {
  paymentToken?: string | null;
  addAmount?: number | null;
  sequenceId?: string | null;
  sessionId?: string | null;
  completeUrl?: string | null;
  cancelUrl?: string | null;
  failUrl?: string | null;
  subscriptionId: string;
  accountId: string;
};

export type Payment = {
  __typename: 'Payment';
  id: string;
  amount?: number | null;
  currency: string;
  orderId?: string | null;
  storeId?: string | null;
  pointOfSaleId?: string | null;
  description?: string | null;
  accountId: string;
  authorizationCode?: string | null;
  livemode?: boolean | null;
  status: PaymentStatus;
  statusCode?: string | null;
  statusMessage?: string | null;
  customer?: Customer | null;
  sequenceId?: string | null;
  subscriptionId?: string | null;
  paymentToken?: string | null;
  paymentMethod?: PaymentMethod | null;
  shop?: Shop | null;
  billingDetails?: ContactDetails | null;
  shippingDetails?: ContactDetails | null;
  refundedAmount?: number | null;
  lastRefundAmount?: number | null;
  lastRefundReason?: RefundReason | null;
  cancellationReason?: CancellationReason | null;
  sessionDetails?: SessionDetails | null;
  traceDetails?: TraceDetails | null;
  nextAction?: NextAction | null;
  createdAt?: number | null;
  updatedAt?: number | null;
  pageOpenedAt?: number | null;
  masterAccountId?: string | null;
};

export type Shop = {
  __typename: 'Shop';
  name: string;
  country?: string | null;
};

export enum RefundReason {
  duplicated = 'duplicated',
  fraudulent = 'fraudulent',
  requested_by_customer = 'requested_by_customer'
}

export enum CancellationReason {
  duplicated = 'duplicated',
  fraudulent = 'fraudulent',
  requested_by_customer = 'requested_by_customer'
}

export type SessionDetails = {
  __typename: 'SessionDetails';
  ip?: string | null;
  userAgent?: string | null;
  countryCode?: string | null;
  lang?: string | null;
  deviceType?: DeviceType | null;
  deviceModel?: string | null;
  browser?: string | null;
  browserVersion?: string | null;
  browserAccept?: string | null;
  browserColorDepth?: string | null;
  browserScreenHeight?: string | null;
  browserScreenWidth?: string | null;
  browserTimezoneOffset?: string | null;
  os?: string | null;
  osVersion?: string | null;
  source?: string | null;
  sourceVersion?: string | null;
};

export type NextAction = {
  __typename: 'NextAction';
  type?: NextActionTypes | null;
  redirectUrl?: string | null;
  mustRedirect?: boolean | null;
};

export enum NextActionTypes {
  CONFIRM = 'CONFIRM',
  CHALLENGE = 'CHALLENGE',
  COMPLETE = 'COMPLETE',
  FRICTIONLESS_CHALLENGE = 'FRICTIONLESS_CHALLENGE',
  BIZUM_CHALLENGE = 'BIZUM_CHALLENGE'
}

export type UpdateSubscriptionInput = {
  amount?: number | null;
  intervalCount?: number | null;
  interval?: Interval | null;
  description?: string | null;
  callbackUrl?: string | null;
  paymentCallbackUrl?: string | null;
  customer?: CustomerInput | null;
  billingDetails?: ContactDetailsInput | null;
  shippingDetails?: ContactDetailsInput | null;
  nextPaymentAt?: number | null;
  trialPeriodEnd?: number | null;
  cancelAtPeriodEnd?: boolean | null;
  pauseIntervalCount?: number | null;
  pauseAtPeriodEnd?: boolean | null;
  accountId: string;
  subscriptionId: string;
};

export type CancelSubscriptionInput = {
  cancelAtPeriodEnd?: boolean | null;
  accountId: string;
  subscriptionId: string;
};

export type PauseSubscriptionInput = {
  pauseIntervalCount: number;
  pauseAtPeriodEnd?: boolean | null;
  accountId: string;
  subscriptionId: string;
};

export type ResumeSubscriptionInput = {
  accountId: string;
  subscriptionId: string;
};

export type CreateMasterAccountInput = {
  adminEmail?: string | null;
  business?: BusinessDataInput | null;
  contractTemplateId?: string | null;
  extraFees?: Array<AccountExtraFeeInput | null> | null;
  iban?: string | null;
  name?: string | null;
  payoutTerms?: AccountPayoutTermsInput | null;
  promoCode?: string | null;
  status?: AccountStatus | null;
  allowedIPs?: Array<string | null> | null;
  accountDefaults?: AccountDefaultsInput | null;
};

export type AccountDefaultsInput = {
  billingPlan?: BillingPlans | null;
  iban?: string | null;
  payoutTerms?: AccountPayoutTermsInput | null;
  fees?: AccountFeesInput | null;
  business?: BusinessDefaultInput | null;
  language?: string | null;
  notifications?: AccountNotificationsInput | null;
};

export type BusinessDefaultInput = {
  mcc?: string | null;
  website?: string | null;
  confirmWebsite?: boolean | null;
  servicesDescription?: string | null;
  confirmServicesDescription?: boolean | null;
};

export type MasterAccount = {
  __typename: 'MasterAccount';
  id: string;
  adminEmail?: string | null;
  apiKey?: string | null;
  business?: BusinessData | null;
  contractTemplateId?: string | null;
  createdAt?: string | null;
  deletedAt?: string | null;
  extraFees?: Array<AccountExtraFee | null> | null;
  iban?: string | null;
  name?: string | null;
  payoutTerms?: AccountPayoutTerms | null;
  promoCode?: string | null;
  status?: AccountStatus | null;
  traceDetails?: TraceDetails | null;
  updatedAt?: string | null;
  allowedIPs?: Array<string | null> | null;
  accountDefaults?: AccountDefaults | null;
};

export type AccountDefaults = {
  __typename: 'AccountDefaults';
  billingPlan?: BillingPlans | null;
  iban?: string | null;
  payoutTerms?: AccountPayoutTerms | null;
  fees?: AccountFees | null;
  business?: BusinessDefault | null;
  language?: string | null;
  notifications?: AccountNotifications | null;
};

export type BusinessDefault = {
  __typename: 'BusinessDefault';
  mcc?: string | null;
  website?: string | null;
  confirmWebsite?: boolean | null;
  servicesDescription?: string | null;
  confirmServicesDescription?: boolean | null;
};

export type UpdateMasterAccountInput = {
  id: string;
  adminEmail?: string | null;
  business?: BusinessDataInput | null;
  contractTemplateId?: string | null;
  extraFees?: Array<AccountExtraFeeInput | null> | null;
  iban?: string | null;
  name?: string | null;
  payoutTerms?: AccountPayoutTermsInput | null;
  promoCode?: string | null;
  status?: AccountStatus | null;
  allowedIPs?: Array<string | null> | null;
  accountDefaults?: AccountDefaultsInput | null;
};

export type CreateDocumentInput = {
  type: DocumentType;
  accountId: string;
  name?: string | null;
  internal?: boolean | null;
  note?: string | null;
};

export type UploadFile = {
  __typename: 'UploadFile';
  uploadUrl: string;
  expiresAt: number;
};

export type AnalyticsChange = {
  __typename: 'AnalyticsChange';
  all?: boolean | null;
};

export type EventsChange = {
  __typename: 'EventsChange';
  accountId?: string | null;
};

export type DocumentsChange = {
  __typename: 'DocumentsChange';
  accountId?: string | null;
};

export type SendPaymentMessageInput = {
  channel?: MessageChannel | null;
  customerEmail?: string | null;
  customerPhone?: string | null;
  language?: string | null;
  paymentId: string;
  accountId: string;
};

export enum MessageChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}

export type SendPaymentRequestInput = {
  paymentId: string;
  phoneNumber: string;
  language?: string | null;
};

export type CreatePaymentInput = {
  id?: string | null;
  amount: number;
  orderId?: string | null;
  storeId?: string | null;
  pointOfSaleId?: string | null;
  description?: string | null;
  customer?: CustomerInput | null;
  billingDetails?: ContactDetailsInput | null;
  shippingDetails?: ContactDetailsInput | null;
  currency?: Currencies | null;
  allowedPaymentMethods?: Array<PaymentMethods | null> | null;
  transactionType?: TransactionTypes | null;
  completeUrl?: string | null;
  callbackUrl?: string | null;
  cancelUrl?: string | null;
  failUrl?: string | null;
  expireAt?: number | null;
  accountId: string;
};

export type RefundPaymentInput = {
  paymentId: string;
  amount: number;
  refundReason?: RefundReason | null;
  accountId: string;
};

export type CapturePaymentInput = {
  paymentId: string;
  amount?: number | null;
  accountId: string;
};

export type CancelPaymentInput = {
  paymentId: string;
  cancellationReason?: CancellationReason | null;
  accountId: string;
};

export type SearchableAccountFilterInput = {
  id?: SearchableIDFilterInput | null;
  name?: SearchableStringFilterInput | null;
  status?: SearchableStringFilterInput | null;
  adminEmail?: SearchableStringFilterInput | null;
  secret?: SearchableStringFilterInput | null;
  apiKey?: SearchableStringFilterInput | null;
  businessCountry?: SearchableStringFilterInput | null;
  businessLegalName?: SearchableStringFilterInput | null;
  businessCompanyName?: SearchableStringFilterInput | null;
  businessEmail?: SearchableStringFilterInput | null;
  billingPlan?: SearchableStringFilterInput | null;
  referralCode?: SearchableStringFilterInput | null;
  promoCode?: SearchableStringFilterInput | null;
  businessWebsite?: SearchableStringFilterInput | null;
  dynamicBilling?: SearchableBooleanFilterInput | null;
  payoutTermsSuspended?: SearchableBooleanFilterInput | null;
  masterAccountId?: SearchableStringFilterInput | null;
  churned?: SearchableBooleanFilterInput | null;
  and?: Array<SearchableAccountFilterInput | null> | null;
  or?: Array<SearchableAccountFilterInput | null> | null;
  not?: SearchableAccountFilterInput | null;
};

export type AccountsConnection = {
  __typename: 'AccountsConnection';
  items: Array<Account>;
  total: number;
};

export type AccountActualFees = {
  __typename: 'AccountActualFees';
  highRiskFee: number;
  dailyPlatformFee: number;
  dailyExtraSeatsFee: number;
  extra?: Array<AccountExtraFee> | null;
  steps: Array<AccountSteps>;
};

export type AvailablePaymentMethod = {
  __typename: 'AvailablePaymentMethod';
  paymentMethod?: PaymentMethods | null;
  configured?: boolean | null;
  enabled?: boolean | null;
};

export type AvailableProcessor = {
  __typename: 'AvailableProcessor';
  paymentMethod?: PaymentMethods | null;
  processor?: Processor | null;
  configured?: boolean | null;
  configurable?: boolean | null;
  enabled?: boolean | null;
};

export type ProviderConfig = {
  __typename: 'ProviderConfig';
  paymentMethod?: PaymentMethods | null;
  processor?: Processor | null;
  acquirers?: Array<Acquirer> | null;
  metadataConfig?: Array<MetadataConfigItem> | null;
};

export type MetadataConfigItem = {
  __typename: 'MetadataConfigItem';
  key: string;
  type: MetadataItemType;
  label?: string | null;
  possibleValues?: Array<string> | null;
  regex?: string | null;
  secret?: boolean | null;
  required?: boolean | null;
  default?: string | null;
  example?: string | null;
  internal?: boolean | null;
};

export type StoresConnection = {
  __typename: 'StoresConnection';
  items: Array<Store>;
  nextToken?: string | null;
};

export type PointsOfSaleConnection = {
  __typename: 'PointsOfSaleConnection';
  items: Array<PointOfSale>;
  nextToken?: string | null;
};

export type CodeConfig = {
  __typename: 'CodeConfig';
  metadataConfig?: Array<MetadataConfigItem> | null;
};

export type ChargesConnection = {
  __typename: 'ChargesConnection';
  items: Array<Charge>;
  total: number;
};

export type Charge = {
  __typename: 'Charge';
  id: string;
  accountId: string;
  providerId?: string | null;
  checkoutId: string;
  providerReferenceId?: string | null;
  providerInternalId?: string | null;
  createdAt: number;
  updatedAt?: number | null;
  amount?: number | null;
  authorizationCode?: string | null;
  billingDetails?: ContactDetails | null;
  billingPlan?: BillingPlans | null;
  currency: string;
  customer?: Customer | null;
  description?: string | null;
  livemode?: boolean | null;
  orderId?: string | null;
  storeId?: string | null;
  pointOfSaleId?: string | null;
  sequenceId?: string | null;
  subscriptionId?: string | null;
  acquirer?: Acquirer | null;
  processor?: Processor | null;
  paymentMethod?: PaymentMethod | null;
  cancellationReason?: CancellationReason | null;
  lastRefundAmount?: number | null;
  lastRefundReason?: RefundReason | null;
  refundedAmount?: number | null;
  shippingDetails?: ContactDetails | null;
  shop?: Shop | null;
  status: ChargeStatus;
  statusCode?: string | null;
  statusMessage?: string | null;
  providerStatusCode?: string | null;
  providerStatusMessage?: string | null;
  issuerStatusCode?: string | null;
  issuerStatusMessage?: string | null;
  sessionDetails?: SessionDetails | null;
  traceDetails?: TraceDetails | null;
  pageOpenedAt?: number | null;
  masterAccountId?: string | null;
};

export enum ChargeStatus {
  SUCCEEDED = 'SUCCEEDED',
  PENDING = 'PENDING',
  PENDING_PROCESSING = 'PENDING_PROCESSING',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  REFUNDED = 'REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  AUTHORIZED = 'AUTHORIZED',
  EXPIRED = 'EXPIRED'
}

export type SearchableEventFilterInput = {
  id?: SearchableIDFilterInput | null;
  accountId?: SearchableIDFilterInput | null;
  objectId?: SearchableIDFilterInput | null;
  type?: SearchableStringFilterInput | null;
  createdAt?: SearchableIntFilterInput | null;
  checkoutId?: SearchableIDFilterInput | null;
  providerReferenceId?: SearchableStringFilterInput | null;
  amount?: SearchableIntFilterInput | null;
  authorizationCode?: SearchableStringFilterInput | null;
  acquirer?: SearchableStringFilterInput | null;
  processor?: SearchableStringFilterInput | null;
  currency?: SearchableStringFilterInput | null;
  description?: SearchableStringFilterInput | null;
  orderId?: SearchableStringFilterInput | null;
  storeId?: SearchableStringFilterInput | null;
  pointOfSaleId?: SearchableStringFilterInput | null;
  sequenceId?: SearchableStringFilterInput | null;
  subscriptionId?: SearchableStringFilterInput | null;
  refundedAmount?: SearchableIntFilterInput | null;
  status?: SearchableStringFilterInput | null;
  statusCode?: SearchableStringFilterInput | null;
  statusMessage?: SearchableStringFilterInput | null;
  customerEmail?: SearchableStringFilterInput | null;
  customerName?: SearchableStringFilterInput | null;
  paymentMethodMethod?: SearchableStringFilterInput | null;
  paymentMethodCardBrand?: SearchableStringFilterInput | null;
  paymentMethodCardLast4?: SearchableStringFilterInput | null;
  paymentMethodCardType?: SearchableStringFilterInput | null;
  paymentMethodCardThreeDSecure?: SearchableBooleanFilterInput | null;
  paymentMethodCardThreeDSecureVersion?: SearchableStringFilterInput | null;
  paymentMethodCardThreeDSecureFlow?: SearchableStringFilterInput | null;
  paymentMethodCardTokenizationMethod?: SearchableStringFilterInput | null;
  shopCountry?: SearchableStringFilterInput | null;
  shopName?: SearchableStringFilterInput | null;
  sessionIp?: SearchableStringFilterInput | null;
  sessionCountry?: SearchableStringFilterInput | null;
  masterAccountId?: SearchableStringFilterInput | null;
  billingPlan?: SearchableStringFilterInput | null;
  and?: Array<SearchableEventFilterInput | null> | null;
  or?: Array<SearchableEventFilterInput | null> | null;
  not?: SearchableEventFilterInput | null;
};

export type ChargeEventsConnection = {
  __typename: 'ChargeEventsConnection';
  items: Array<ChargeEvent>;
  total: number;
};

export type ChargeEvent = {
  __typename: 'ChargeEvent';
  id: string;
  type: string;
  accountId: string;
  livemode?: boolean | null;
  objectId: string;
  objectType: string;
  object: ChargeEventObject;
  createdAt?: number | null;
};

export type ChargeEventObject = {
  __typename: 'ChargeEventObject';
  id: string;
  accountId: string;
  providerId?: string | null;
  checkoutId: string;
  providerReferenceId?: string | null;
  providerInternalId?: string | null;
  createdAt?: number | null;
  updatedAt?: number | null;
  amount?: number | null;
  authorizationCode?: string | null;
  billingDetails?: ContactDetails | null;
  billingPlan?: BillingPlans | null;
  currency: string;
  customer?: Customer | null;
  description?: string | null;
  livemode?: boolean | null;
  orderId?: string | null;
  storeId?: string | null;
  pointOfSaleId?: string | null;
  sequenceId?: string | null;
  subscriptionId?: string | null;
  paymentMethod?: PaymentMethod | null;
  cancellationReason?: CancellationReason | null;
  lastRefundAmount?: number | null;
  lastRefundReason?: RefundReason | null;
  refundedAmount?: number | null;
  shippingDetails?: ContactDetails | null;
  shop?: Shop | null;
  status: ChargeStatus;
  statusCode?: string | null;
  statusMessage?: string | null;
  providerStatusCode?: string | null;
  providerStatusMessage?: string | null;
  issuerStatusCode?: string | null;
  issuerStatusMessage?: string | null;
  sessionDetails?: SessionDetails | null;
  traceDetails?: TraceDetails | null;
  pageOpenedAt?: number | null;
  masterAccountId?: string | null;
};

export type AccountEventsConnection = {
  __typename: 'AccountEventsConnection';
  items: Array<AccountEvent>;
  total: number;
};

export type AccountEvent = {
  __typename: 'AccountEvent';
  id: string;
  type: string;
  accountId: string;
  livemode?: boolean | null;
  objectId: string;
  objectType: string;
  object: AccountEventObject;
  createdAt?: number | null;
};

export type AccountEventObject = {
  __typename: 'AccountEventObject';
  id: string;
  name?: string | null;
  status: AccountStatus;
  reason?: string | null;
  note?: string | null;
  partner?: Partner | null;
  acquirer?: Acquirer | null;
  adminEmail?: string | null;
  riskScore?: number | null;
  timezone?: string | null;
  language?: string | null;
  paymentMethods?: AccountPaymentMethods | null;
  defaultCurrency?: Currencies | null;
  defaultTransactionType?: TransactionTypes | null;
  business?: BusinessData | null;
  representatives?: Array<Representative> | null;
  publicBusinessDetails?: AccountPublicBusinessDetails | null;
  branding?: AccountBranding | null;
  payoutTerms?: AccountPayoutTerms | null;
  iban?: string | null;
  fees?: AccountFees | null;
  test?: boolean | null;
  customDomain?: string | null;
  dynamicBilling?: boolean | null;
  tokenizationMethods?: AccountTokenizationMethods | null;
  referralCode?: string | null;
  promoCode?: string | null;
  billingPlan?: BillingPlans | null;
  notifications?: AccountNotifications | null;
  contract?: AccountContract | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  deletedAt?: string | null;
  approvedAt?: string | null;
  rejectedAt?: string | null;
  activatedAt?: string | null;
  approvalRequestedAt?: string | null;
  suspendedAt?: string | null;
  dataUpdatedAt?: string | null;
  traceDetails?: TraceDetails | null;
  billingVatPercent?: number | null;
  allowCreateApiKey?: boolean | null;
  masterAccountId?: string | null;
  reviewConfirmed?: boolean | null;
  churned?: boolean | null;
};

export type AccountStats = {
  __typename: 'AccountStats';
  accountId: string;
  stats?: Stats | null;
};

export type Stats = {
  __typename: 'Stats';
  firstTransactionAt?: string | null;
  activeMonths?: number | null;
  avgMonthlyTransactions?: number | null;
  avgMonthlyVolume?: number | null;
  churned?: boolean | null;
  totalSucceededCount?: number | null;
  lastTransactionAt?: string | null;
  totalSucceededAmount?: number | null;
};

export type SearchableSubscriptionFilterInput = {
  id?: SearchableIDFilterInput | null;
  accountId?: SearchableIDFilterInput | null;
  createdAt?: SearchableIntFilterInput | null;
  updatedAt?: SearchableIntFilterInput | null;
  amount?: SearchableIntFilterInput | null;
  currency?: SearchableStringFilterInput | null;
  description?: SearchableStringFilterInput | null;
  lastOrderId?: SearchableStringFilterInput | null;
  sequenceId?: SearchableStringFilterInput | null;
  status?: SearchableStringFilterInput | null;
  interval?: SearchableStringFilterInput | null;
  intervalCount?: SearchableIntFilterInput | null;
  lastPaymentId?: SearchableIDFilterInput | null;
  lastPaymentStatus?: SearchableStringFilterInput | null;
  lastPaymentStatusCode?: SearchableStringFilterInput | null;
  customerEmail?: SearchableStringFilterInput | null;
  customerName?: SearchableStringFilterInput | null;
  customerPhone?: SearchableStringFilterInput | null;
  paymentMethodMethod?: SearchableStringFilterInput | null;
  paymentMethodCardBrand?: SearchableStringFilterInput | null;
  paymentMethodCardLast4?: SearchableStringFilterInput | null;
  paymentMethodCardType?: SearchableStringFilterInput | null;
  paymentMethodCardThreeDSecure?: SearchableBooleanFilterInput | null;
  paymentMethodCardThreeDSecureVersion?: SearchableStringFilterInput | null;
  paymentMethodCardThreeDSecureFlow?: SearchableStringFilterInput | null;
  paymentMethodCardTokenizationMethod?: SearchableStringFilterInput | null;
  traceDetailsSource?: SearchableStringFilterInput | null;
  storeId?: SearchableStringFilterInput | null;
  masterAccountId?: SearchableStringFilterInput | null;
  and?: Array<SearchableSubscriptionFilterInput | null> | null;
  or?: Array<SearchableSubscriptionFilterInput | null> | null;
  not?: SearchableSubscriptionFilterInput | null;
};

export type SubscriptionsConnection = {
  __typename: 'SubscriptionsConnection';
  items: Array<Subscription>;
  total: number;
};

export type Countries = {
  __typename: 'Countries';
  supportedCountries: Array<Country>;
  currentCountry?: Country | null;
  currentCountryCode?: string | null;
  isSupported: boolean;
};

export type Country = {
  __typename: 'Country';
  name: string;
  phoneCode: string;
  code: string;
};

export type ChargesDateRangeKPI = {
  __typename: 'ChargesDateRangeKPI';
  currency: string;
  total: ChargesDateRangeKPITotal;
  data: Array<ChargesDateRangeKPIRow>;
};

export type ChargesDateRangeKPITotal = {
  __typename: 'ChargesDateRangeKPITotal';
  succeededAmount: string;
  succeededCount: string;
  capturedAmount: string;
  capturedCount: string;
  directAmount: string;
  directCount: string;
  canceledAmount: string;
  canceledCount: string;
  refundedAmount: string;
  refundedCount: string;
  failedAmount: string;
  failedCount: string;
};

export type ChargesDateRangeKPIRow = {
  __typename: 'ChargesDateRangeKPIRow';
  timestamp: number;
  succeededAmount: string;
  succeededCount: string;
  capturedAmount: string;
  capturedCount: string;
  directAmount: string;
  directCount: string;
  canceledAmount: string;
  canceledCount: string;
  refundedAmount: string;
  refundedCount: string;
  failedAmount: string;
  failedCount: string;
  cuSucceededAmount: string;
  cuSucceededCount: string;
  cuCapturedAmount: string;
  cuCapturedCount: string;
  cuDirectAmount: string;
  cuDirectCount: string;
};

export type UsersConnection = {
  __typename: 'UsersConnection';
  items: Array<User>;
  nextToken?: string | null;
};

export type SettlementEventsConnection = {
  __typename: 'SettlementEventsConnection';
  items: Array<SettlementEvent>;
  total: number;
};

export type SettlementEvent = {
  __typename: 'SettlementEvent';
  id: string;
  type: string;
  accountId: string;
  objectId: string;
  objectType: string;
  object: SettlementEventObject;
  createdAt: number;
};

export type SettlementEventObject = {
  __typename: 'SettlementEventObject';
  accountId: string;
  acquirer: SettlementAcquirer;
  acquirerFees: number;
  createdAt: number;
  grossVolume: number;
  iban?: string | null;
  id: string;
  legalName?: string | null;
  netVolume: number;
  period: number;
  payMethod?: SettlementPayMethods | null;
  periodEndAt: number;
  periodStartAt: number;
  previousNegative?: boolean | null;
  releasedAmount?: number | null;
  reservedAmount?: number | null;
  reservePercent: number;
  scheduledAt: number;
  status: SettlementStatus;
  updatedAt: number;
};

export enum SettlementAcquirer {
  COMERCIA_GLOBAL_PAY = 'COMERCIA_GLOBAL_PAY',
  CREDORAX = 'CREDORAX'
}

export enum SettlementPayMethods {
  bizum = 'bizum',
  card = 'card'
}

export enum SettlementStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  SUSPENDED = 'SUSPENDED'
}

export type DocumentsConnection = {
  __typename: 'DocumentsConnection';
  items: Array<Document>;
  nextToken?: string | null;
};

export type DocumentEventsConnection = {
  __typename: 'DocumentEventsConnection';
  items: Array<DocumentEvent>;
  total: number;
};

export type DocumentEvent = {
  __typename: 'DocumentEvent';
  id: string;
  type: string;
  accountId: string;
  objectId: string;
  objectType: string;
  object: DocumentEventObject;
  createdAt: number;
};

export type DocumentEventObject = {
  __typename: 'DocumentEventObject';
  id: string;
  accountId: string;
  type: DocumentType;
  status: DocumentStatus;
  statusCode?: string | null;
  statusMessage?: string | null;
  contentType?: string | null;
  createdAt: number;
  updatedAt?: number | null;
  name?: string | null;
  note?: string | null;
  internal?: boolean | null;
  traceDetails?: TraceDetails | null;
  metadata?: Array<DocumentMetadataItem> | null;
};

export type SearchableSettlementEventFilterInput = {
  id?: SearchableIDFilterInput | null;
  accountId?: SearchableIDFilterInput | null;
  acquirer?: SearchableStringFilterInput | null;
  acquirerFees?: SearchableIntFilterInput | null;
  createdAt?: SearchableIntFilterInput | null;
  grossVolume?: SearchableIntFilterInput | null;
  iban?: SearchableStringFilterInput | null;
  legalName?: SearchableStringFilterInput | null;
  netVolume?: SearchableIntFilterInput | null;
  objectId?: SearchableIDFilterInput | null;
  payMethod?: SearchableStringFilterInput | null;
  period?: SearchableIntFilterInput | null;
  periodEndAt?: SearchableIntFilterInput | null;
  periodStartAt?: SearchableIntFilterInput | null;
  previousNegative?: SearchableBooleanFilterInput | null;
  releasedAmount?: SearchableIntFilterInput | null;
  reservedAmount?: SearchableIntFilterInput | null;
  reservePercent?: SearchableIntFilterInput | null;
  scheduledAt?: SearchableIntFilterInput | null;
  status?: SearchableStringFilterInput | null;
  updatedAt?: SearchableIntFilterInput | null;
  and?: Array<SearchableSettlementEventFilterInput | null> | null;
  or?: Array<SearchableSettlementEventFilterInput | null> | null;
  not?: SearchableSettlementEventFilterInput | null;
};

export type SearchableSettlementFilterInput = {
  id?: SearchableIDFilterInput | null;
  accountId?: SearchableIDFilterInput | null;
  acquirer?: SearchableStringFilterInput | null;
  acquirerFees?: SearchableIntFilterInput | null;
  createdAt?: SearchableIntFilterInput | null;
  grossVolume?: SearchableIntFilterInput | null;
  iban?: SearchableStringFilterInput | null;
  legalName?: SearchableStringFilterInput | null;
  netVolume?: SearchableIntFilterInput | null;
  payMethod?: SearchableStringFilterInput | null;
  period?: SearchableIntFilterInput | null;
  periodEndAt?: SearchableIntFilterInput | null;
  periodStartAt?: SearchableIntFilterInput | null;
  previousNegative?: SearchableBooleanFilterInput | null;
  releasedAmount?: SearchableIntFilterInput | null;
  reservedAmount?: SearchableIntFilterInput | null;
  reservePercent?: SearchableIntFilterInput | null;
  scheduledAt?: SearchableIntFilterInput | null;
  status?: SearchableStringFilterInput | null;
  updatedAt?: SearchableIntFilterInput | null;
  and?: Array<SearchableSettlementFilterInput | null> | null;
  or?: Array<SearchableSettlementFilterInput | null> | null;
  not?: SearchableSettlementFilterInput | null;
};

export type SettlementsConnection = {
  __typename: 'SettlementsConnection';
  items: Array<Settlement>;
  total: number;
};

export type Settlement = {
  __typename: 'Settlement';
  accountId: string;
  acquirer: SettlementAcquirer;
  acquirerFees: number;
  createdAt: number;
  grossVolume: number;
  iban?: string | null;
  id: string;
  legalName?: string | null;
  netVolume: number;
  payMethod?: SettlementPayMethods | null;
  period: number;
  periodEndAt: number;
  periodStartAt: number;
  previousNegative?: boolean | null;
  releasedAmount?: number | null;
  reservedAmount?: number | null;
  reservePercent: number;
  scheduledAt: number;
  status: SettlementStatus;
  updatedAt: number;
};

export type SearchableInvoiceFilterInput = {
  accountId?: SearchableIDFilterInput | null;
  currency?: SearchableStringFilterInput | null;
  amount?: SearchableIntFilterInput | null;
  tax?: SearchableIntFilterInput | null;
  totalAmount?: SearchableIntFilterInput | null;
  and?: Array<SearchableInvoiceFilterInput | null> | null;
  or?: Array<SearchableInvoiceFilterInput | null> | null;
  not?: SearchableInvoiceFilterInput | null;
};

export type InvoicesConnection = {
  __typename: 'InvoicesConnection';
  items: Array<AccountInvoice>;
  total: number;
};

export type AuthorizedUsersConnection = {
  __typename: 'AuthorizedUsersConnection';
  items: Array<AuthorizedUser>;
};

export enum PaymentEmailType {
  PAYMENT_LINK = 'PAYMENT_LINK',
  RECEIPT = 'RECEIPT'
}

export type MasterAccountsConnection = {
  __typename: 'MasterAccountsConnection';
  items: Array<MasterAccount>;
};

export type UpdateAccountMutationVariables = {
  input: UpdateAccountInput;
};

export type UpdateAccountMutation = {
  updateAccount: {
    __typename: 'Account';
    id: string;
    name?: string | null;
    status: AccountStatus;
    reason?: string | null;
    note?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    riskScore?: number | null;
    timezone?: string | null;
    language?: string | null;
    paymentMethods?: {
      __typename: 'AccountPaymentMethods';
      CREDITCARD?: {
        __typename: 'AccountPaymentMethodsCreditCard';
        enabled?: boolean | null;
        allowPaymentDetails?: boolean | null;
        preauthorization?: boolean | null;
      } | null;
      BIZUM?: {
        __typename: 'AccountPaymentMethodsBizum';
        enabled?: boolean | null;
      } | null;
    } | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    representatives?: Array<{
      __typename: 'Representative';
      firstName?: string | null;
      lastName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      dateOfBirth?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      document?: {
        __typename: 'IdDocument';
        type?: string | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      idSession?: string | null;
      idSessionUrl?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusMessage?: string | null;
      statusCode?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      hasNoPublicActivity?: boolean | null;
      nationality?: string | null;
      citizenship?: string | null;
      registeredAt?: string | null;
      deletedAt?: string | null;
    }> | null;
    publicBusinessDetails?: {
      __typename: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      supportWebsite?: string | null;
      supportEmail?: string | null;
      supportPhone?: string | null;
    } | null;
    branding?: {
      __typename: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    iban?: string | null;
    fees?: {
      __typename: 'AccountFees';
      trxFee?: number | null;
      trxFlatFee?: number | null;
      highRiskFee?: number | null;
      dailyPlatformFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      extra?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      }> | null;
      steps?: Array<{
        __typename: 'AccountSteps';
        from: number;
        trxFee: number;
        trxFlatFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        multibancoTrxFee?: number | null;
        multibancoTrxFlatFee?: number | null;
      }> | null;
    } | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    dynamicBilling?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    tokenizationMethods?: {
      __typename: 'AccountTokenizationMethods';
      googlePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      applePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      clickToPay?: {
        __typename: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
        dpaId?: string | null;
      } | null;
    } | null;
    referralCode?: string | null;
    promoCode?: string | null;
    billingPlan?: BillingPlans | null;
    notifications?: {
      __typename: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
    } | null;
    contract?: {
      __typename: 'AccountContract';
      envelopeId: string;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    billingVatPercent?: number | null;
    allowCreateApiKey?: boolean | null;
    masterAccountId?: string | null;
    reviewConfirmed?: boolean | null;
    churned?: boolean | null;
  };
};

export type UpdateDocumentMutationVariables = {
  input: UpdateDocumentInput;
};

export type UpdateDocumentMutation = {
  updateDocument: {
    __typename: 'Document';
    id: string;
    accountId: string;
    type: DocumentType;
    status: DocumentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    contentType?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    name?: string | null;
    note?: string | null;
    internal?: boolean | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    metadata?: Array<{
      __typename: 'DocumentMetadataItem';
      key: string;
      value?: string | null;
    }> | null;
  };
};

export type VerifyBusinessDetailsMutationVariables = {
  input: UpdateAccountInput;
};

export type VerifyBusinessDetailsMutation = {
  verifyBusinessDetails: {
    __typename: 'Account';
    id: string;
    name?: string | null;
    status: AccountStatus;
    reason?: string | null;
    note?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    riskScore?: number | null;
    timezone?: string | null;
    language?: string | null;
    paymentMethods?: {
      __typename: 'AccountPaymentMethods';
      CREDITCARD?: {
        __typename: 'AccountPaymentMethodsCreditCard';
        enabled?: boolean | null;
        allowPaymentDetails?: boolean | null;
        preauthorization?: boolean | null;
      } | null;
      BIZUM?: {
        __typename: 'AccountPaymentMethodsBizum';
        enabled?: boolean | null;
      } | null;
    } | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    representatives?: Array<{
      __typename: 'Representative';
      firstName?: string | null;
      lastName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      dateOfBirth?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      document?: {
        __typename: 'IdDocument';
        type?: string | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      idSession?: string | null;
      idSessionUrl?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusMessage?: string | null;
      statusCode?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      hasNoPublicActivity?: boolean | null;
      nationality?: string | null;
      citizenship?: string | null;
      registeredAt?: string | null;
      deletedAt?: string | null;
    }> | null;
    publicBusinessDetails?: {
      __typename: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      supportWebsite?: string | null;
      supportEmail?: string | null;
      supportPhone?: string | null;
    } | null;
    branding?: {
      __typename: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    iban?: string | null;
    fees?: {
      __typename: 'AccountFees';
      trxFee?: number | null;
      trxFlatFee?: number | null;
      highRiskFee?: number | null;
      dailyPlatformFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      extra?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      }> | null;
      steps?: Array<{
        __typename: 'AccountSteps';
        from: number;
        trxFee: number;
        trxFlatFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        multibancoTrxFee?: number | null;
        multibancoTrxFlatFee?: number | null;
      }> | null;
    } | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    dynamicBilling?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    tokenizationMethods?: {
      __typename: 'AccountTokenizationMethods';
      googlePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      applePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      clickToPay?: {
        __typename: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
        dpaId?: string | null;
      } | null;
    } | null;
    referralCode?: string | null;
    promoCode?: string | null;
    billingPlan?: BillingPlans | null;
    notifications?: {
      __typename: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
    } | null;
    contract?: {
      __typename: 'AccountContract';
      envelopeId: string;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    billingVatPercent?: number | null;
    allowCreateApiKey?: boolean | null;
    masterAccountId?: string | null;
    reviewConfirmed?: boolean | null;
    churned?: boolean | null;
  };
};

export type DeleteAccountMutationVariables = {
  id: string;
};

export type DeleteAccountMutation = {
  deleteAccount: {
    __typename: 'Account';
    id: string;
    name?: string | null;
    status: AccountStatus;
    reason?: string | null;
    note?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    riskScore?: number | null;
    timezone?: string | null;
    language?: string | null;
    paymentMethods?: {
      __typename: 'AccountPaymentMethods';
      CREDITCARD?: {
        __typename: 'AccountPaymentMethodsCreditCard';
        enabled?: boolean | null;
        allowPaymentDetails?: boolean | null;
        preauthorization?: boolean | null;
      } | null;
      BIZUM?: {
        __typename: 'AccountPaymentMethodsBizum';
        enabled?: boolean | null;
      } | null;
    } | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    representatives?: Array<{
      __typename: 'Representative';
      firstName?: string | null;
      lastName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      dateOfBirth?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      document?: {
        __typename: 'IdDocument';
        type?: string | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      idSession?: string | null;
      idSessionUrl?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusMessage?: string | null;
      statusCode?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      hasNoPublicActivity?: boolean | null;
      nationality?: string | null;
      citizenship?: string | null;
      registeredAt?: string | null;
      deletedAt?: string | null;
    }> | null;
    publicBusinessDetails?: {
      __typename: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      supportWebsite?: string | null;
      supportEmail?: string | null;
      supportPhone?: string | null;
    } | null;
    branding?: {
      __typename: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    iban?: string | null;
    fees?: {
      __typename: 'AccountFees';
      trxFee?: number | null;
      trxFlatFee?: number | null;
      highRiskFee?: number | null;
      dailyPlatformFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      extra?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      }> | null;
      steps?: Array<{
        __typename: 'AccountSteps';
        from: number;
        trxFee: number;
        trxFlatFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        multibancoTrxFee?: number | null;
        multibancoTrxFlatFee?: number | null;
      }> | null;
    } | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    dynamicBilling?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    tokenizationMethods?: {
      __typename: 'AccountTokenizationMethods';
      googlePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      applePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      clickToPay?: {
        __typename: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
        dpaId?: string | null;
      } | null;
    } | null;
    referralCode?: string | null;
    promoCode?: string | null;
    billingPlan?: BillingPlans | null;
    notifications?: {
      __typename: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
    } | null;
    contract?: {
      __typename: 'AccountContract';
      envelopeId: string;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    billingVatPercent?: number | null;
    allowCreateApiKey?: boolean | null;
    masterAccountId?: string | null;
    reviewConfirmed?: boolean | null;
    churned?: boolean | null;
  };
};

export type RestoreAccountMutationVariables = {
  id: string;
};

export type RestoreAccountMutation = {
  restoreAccount: {
    __typename: 'Account';
    id: string;
    name?: string | null;
    status: AccountStatus;
    reason?: string | null;
    note?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    riskScore?: number | null;
    timezone?: string | null;
    language?: string | null;
    paymentMethods?: {
      __typename: 'AccountPaymentMethods';
      CREDITCARD?: {
        __typename: 'AccountPaymentMethodsCreditCard';
        enabled?: boolean | null;
        allowPaymentDetails?: boolean | null;
        preauthorization?: boolean | null;
      } | null;
      BIZUM?: {
        __typename: 'AccountPaymentMethodsBizum';
        enabled?: boolean | null;
      } | null;
    } | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    representatives?: Array<{
      __typename: 'Representative';
      firstName?: string | null;
      lastName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      dateOfBirth?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      document?: {
        __typename: 'IdDocument';
        type?: string | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      idSession?: string | null;
      idSessionUrl?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusMessage?: string | null;
      statusCode?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      hasNoPublicActivity?: boolean | null;
      nationality?: string | null;
      citizenship?: string | null;
      registeredAt?: string | null;
      deletedAt?: string | null;
    }> | null;
    publicBusinessDetails?: {
      __typename: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      supportWebsite?: string | null;
      supportEmail?: string | null;
      supportPhone?: string | null;
    } | null;
    branding?: {
      __typename: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    iban?: string | null;
    fees?: {
      __typename: 'AccountFees';
      trxFee?: number | null;
      trxFlatFee?: number | null;
      highRiskFee?: number | null;
      dailyPlatformFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      extra?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      }> | null;
      steps?: Array<{
        __typename: 'AccountSteps';
        from: number;
        trxFee: number;
        trxFlatFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        multibancoTrxFee?: number | null;
        multibancoTrxFlatFee?: number | null;
      }> | null;
    } | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    dynamicBilling?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    tokenizationMethods?: {
      __typename: 'AccountTokenizationMethods';
      googlePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      applePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      clickToPay?: {
        __typename: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
        dpaId?: string | null;
      } | null;
    } | null;
    referralCode?: string | null;
    promoCode?: string | null;
    billingPlan?: BillingPlans | null;
    notifications?: {
      __typename: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
    } | null;
    contract?: {
      __typename: 'AccountContract';
      envelopeId: string;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    billingVatPercent?: number | null;
    allowCreateApiKey?: boolean | null;
    masterAccountId?: string | null;
    reviewConfirmed?: boolean | null;
    churned?: boolean | null;
  };
};

export type ApproveAccountMutationVariables = {
  id: string;
  processor?: Processor | null;
};

export type ApproveAccountMutation = {
  approveAccount: {
    __typename: 'Account';
    id: string;
    name?: string | null;
    status: AccountStatus;
    reason?: string | null;
    note?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    riskScore?: number | null;
    timezone?: string | null;
    language?: string | null;
    paymentMethods?: {
      __typename: 'AccountPaymentMethods';
      CREDITCARD?: {
        __typename: 'AccountPaymentMethodsCreditCard';
        enabled?: boolean | null;
        allowPaymentDetails?: boolean | null;
        preauthorization?: boolean | null;
      } | null;
      BIZUM?: {
        __typename: 'AccountPaymentMethodsBizum';
        enabled?: boolean | null;
      } | null;
    } | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    representatives?: Array<{
      __typename: 'Representative';
      firstName?: string | null;
      lastName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      dateOfBirth?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      document?: {
        __typename: 'IdDocument';
        type?: string | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      idSession?: string | null;
      idSessionUrl?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusMessage?: string | null;
      statusCode?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      hasNoPublicActivity?: boolean | null;
      nationality?: string | null;
      citizenship?: string | null;
      registeredAt?: string | null;
      deletedAt?: string | null;
    }> | null;
    publicBusinessDetails?: {
      __typename: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      supportWebsite?: string | null;
      supportEmail?: string | null;
      supportPhone?: string | null;
    } | null;
    branding?: {
      __typename: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    iban?: string | null;
    fees?: {
      __typename: 'AccountFees';
      trxFee?: number | null;
      trxFlatFee?: number | null;
      highRiskFee?: number | null;
      dailyPlatformFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      extra?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      }> | null;
      steps?: Array<{
        __typename: 'AccountSteps';
        from: number;
        trxFee: number;
        trxFlatFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        multibancoTrxFee?: number | null;
        multibancoTrxFlatFee?: number | null;
      }> | null;
    } | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    dynamicBilling?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    tokenizationMethods?: {
      __typename: 'AccountTokenizationMethods';
      googlePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      applePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      clickToPay?: {
        __typename: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
        dpaId?: string | null;
      } | null;
    } | null;
    referralCode?: string | null;
    promoCode?: string | null;
    billingPlan?: BillingPlans | null;
    notifications?: {
      __typename: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
    } | null;
    contract?: {
      __typename: 'AccountContract';
      envelopeId: string;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    billingVatPercent?: number | null;
    allowCreateApiKey?: boolean | null;
    masterAccountId?: string | null;
    reviewConfirmed?: boolean | null;
    churned?: boolean | null;
  };
};

export type RegisterMoneiXMerchantMutationVariables = {
  id: string;
};

export type RegisterMoneiXMerchantMutation = {
  registerMoneiXMerchant: {
    __typename: 'SuccessResult';
    success: boolean;
  };
};

export type VerifyIdMutationVariables = {
  id: number;
  accountId: string;
};

export type VerifyIdMutation = {
  verifyId: {
    __typename: 'Account';
    id: string;
    name?: string | null;
    status: AccountStatus;
    reason?: string | null;
    note?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    riskScore?: number | null;
    timezone?: string | null;
    language?: string | null;
    paymentMethods?: {
      __typename: 'AccountPaymentMethods';
      CREDITCARD?: {
        __typename: 'AccountPaymentMethodsCreditCard';
        enabled?: boolean | null;
        allowPaymentDetails?: boolean | null;
        preauthorization?: boolean | null;
      } | null;
      BIZUM?: {
        __typename: 'AccountPaymentMethodsBizum';
        enabled?: boolean | null;
      } | null;
    } | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    representatives?: Array<{
      __typename: 'Representative';
      firstName?: string | null;
      lastName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      dateOfBirth?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      document?: {
        __typename: 'IdDocument';
        type?: string | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      idSession?: string | null;
      idSessionUrl?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusMessage?: string | null;
      statusCode?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      hasNoPublicActivity?: boolean | null;
      nationality?: string | null;
      citizenship?: string | null;
      registeredAt?: string | null;
      deletedAt?: string | null;
    }> | null;
    publicBusinessDetails?: {
      __typename: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      supportWebsite?: string | null;
      supportEmail?: string | null;
      supportPhone?: string | null;
    } | null;
    branding?: {
      __typename: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    iban?: string | null;
    fees?: {
      __typename: 'AccountFees';
      trxFee?: number | null;
      trxFlatFee?: number | null;
      highRiskFee?: number | null;
      dailyPlatformFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      extra?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      }> | null;
      steps?: Array<{
        __typename: 'AccountSteps';
        from: number;
        trxFee: number;
        trxFlatFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        multibancoTrxFee?: number | null;
        multibancoTrxFlatFee?: number | null;
      }> | null;
    } | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    dynamicBilling?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    tokenizationMethods?: {
      __typename: 'AccountTokenizationMethods';
      googlePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      applePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      clickToPay?: {
        __typename: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
        dpaId?: string | null;
      } | null;
    } | null;
    referralCode?: string | null;
    promoCode?: string | null;
    billingPlan?: BillingPlans | null;
    notifications?: {
      __typename: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
    } | null;
    contract?: {
      __typename: 'AccountContract';
      envelopeId: string;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    billingVatPercent?: number | null;
    allowCreateApiKey?: boolean | null;
    masterAccountId?: string | null;
    reviewConfirmed?: boolean | null;
    churned?: boolean | null;
  };
};

export type CreateProviderMutationVariables = {
  input: CreateProviderInput;
};

export type CreateProviderMutation = {
  createProvider: {
    __typename: 'Provider';
    id: string;
    processor?: Processor | null;
    enabled?: boolean | null;
    test?: boolean | null;
    paymentMethod?: PaymentMethods | null;
    acquirer?: Acquirer | null;
    configurable?: boolean | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
    nativeHostedPayment?: boolean | null;
    rules?: {
      __typename: 'ProviderRules';
      minAmount?: number | null;
      maxAmount?: number | null;
      shopNameLike?: string | null;
      descriptionLike?: string | null;
    } | null;
  };
};

export type UpdateProviderMutationVariables = {
  input: UpdateProviderInput;
};

export type UpdateProviderMutation = {
  updateProvider: {
    __typename: 'Provider';
    id: string;
    processor?: Processor | null;
    enabled?: boolean | null;
    test?: boolean | null;
    paymentMethod?: PaymentMethods | null;
    acquirer?: Acquirer | null;
    configurable?: boolean | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
    nativeHostedPayment?: boolean | null;
    rules?: {
      __typename: 'ProviderRules';
      minAmount?: number | null;
      maxAmount?: number | null;
      shopNameLike?: string | null;
      descriptionLike?: string | null;
    } | null;
  };
};

export type DeleteProviderMutationVariables = {
  id: string;
};

export type DeleteProviderMutation = {
  deleteProvider: {
    __typename: 'Provider';
    id: string;
    processor?: Processor | null;
    enabled?: boolean | null;
    test?: boolean | null;
    paymentMethod?: PaymentMethods | null;
    acquirer?: Acquirer | null;
    configurable?: boolean | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
    nativeHostedPayment?: boolean | null;
    rules?: {
      __typename: 'ProviderRules';
      minAmount?: number | null;
      maxAmount?: number | null;
      shopNameLike?: string | null;
      descriptionLike?: string | null;
    } | null;
  };
};

export type CreateStoreMutationVariables = {
  input: CreateStoreInput;
};

export type CreateStoreMutation = {
  createStore: {
    __typename: 'Store';
    id: string;
    accountId: string;
    name?: string | null;
  };
};

export type UpdateStoreMutationVariables = {
  input: UpdateStoreInput;
};

export type UpdateStoreMutation = {
  updateStore: {
    __typename: 'Store';
    id: string;
    accountId: string;
    name?: string | null;
  };
};

export type CreatePointOfSaleMutationVariables = {
  input: CreatePointOfSaleInput;
};

export type CreatePointOfSaleMutation = {
  createPointOfSale: {
    __typename: 'PointOfSale';
    id: string;
    accountId: string;
    storeId: string;
    number: number;
    name?: string | null;
    currentPaymentId?: string | null;
    manualAmount?: boolean | null;
  };
};

export type UpdatePointOfSaleMutationVariables = {
  input: UpdatePointOfSaleInput;
};

export type UpdatePointOfSaleMutation = {
  updatePointOfSale: {
    __typename: 'PointOfSale';
    id: string;
    accountId: string;
    storeId: string;
    number: number;
    name?: string | null;
    currentPaymentId?: string | null;
    manualAmount?: boolean | null;
  };
};

export type CreateCodeMutationVariables = {
  input: CreateCodeInput;
};

export type CreateCodeMutation = {
  createCode: {
    __typename: 'Code';
    id: string;
    type: CodeTypes;
    enabled?: boolean | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
  };
};

export type UpdateCodeMutationVariables = {
  input: UpdateCodeInput;
};

export type UpdateCodeMutation = {
  updateCode: {
    __typename: 'Code';
    id: string;
    type: CodeTypes;
    enabled?: boolean | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
  };
};

export type CreateAuthorizedUserMutationVariables = {
  input: CreateAuthorizedUserInput;
};

export type CreateAuthorizedUserMutation = {
  createAuthorizedUser?: {
    __typename: 'AuthorizedUser';
    accountId?: string | null;
    userEmail: string;
    id?: string | null;
    accessLevel: AuthorizedUserAccessLevel;
    storeId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type DeleteAuthorizedUserMutationVariables = {
  userEmail: string;
  accountId: string;
};

export type DeleteAuthorizedUserMutation = {
  deleteAuthorizedUser?: {
    __typename: 'AuthorizedUser';
    accountId?: string | null;
    userEmail: string;
    id?: string | null;
    accessLevel: AuthorizedUserAccessLevel;
    storeId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type UpdateAuthorizedUserMutationVariables = {
  input: UpdateAuthorizedUserInput;
};

export type UpdateAuthorizedUserMutation = {
  updateAuthorizedUser?: {
    __typename: 'AuthorizedUser';
    accountId?: string | null;
    userEmail: string;
    id?: string | null;
    accessLevel: AuthorizedUserAccessLevel;
    storeId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type CreateAccountInvoiceMutationVariables = {
  input: AccountInvoiceInput;
};

export type CreateAccountInvoiceMutation = {
  createAccountInvoice: {
    __typename: 'AccountInvoice';
    accountId: string;
    period: {
      __typename: 'AccountInvoicePeriod';
      from?: number | null;
      to?: number | null;
    };
    currency: string;
    amount: number;
    tax: number;
    totalAmount: number;
    lineItems: Array<{
      __typename: 'AccountInvoiceLineItem';
      name: string;
      quantity: number;
      unitAmount: number;
      unitType: InvoiceLineItemUnitType;
      currency: string;
      amount: number;
    }>;
    createdAt: number;
    business?: {
      __typename: 'InvoiceBusinessData';
      legalName?: string | null;
      iban?: string | null;
      documentNumber?: string | null;
      mandateSignatureTimestamp?: string | null;
    } | null;
  };
};

export type ResetUserPasswordMutationVariables = {
  userId: string;
  temporalPassword?: string | null;
};

export type ResetUserPasswordMutation = {
  resetUserPassword: string;
};

export type ImpersonateMutationVariables = {
  input: ImpersonateInput;
};

export type ImpersonateMutation = {
  impersonate?: boolean | null;
};

export type ExportChargesMutationVariables = {
  filter?: SearchableChargeFilterInput | null;
  columns?: Array<string> | null;
  timezone?: string | null;
};

export type ExportChargesMutation = {
  exportCharges: {
    __typename: 'DownloadFile';
    downloadUrl: string;
    expiresAt: number;
  };
};

export type GenerateQRCodesMutationVariables = {
  batchSize: number;
};

export type GenerateQRCodesMutation = {
  generateQRCodes?: {
    __typename: 'DownloadFile';
    downloadUrl: string;
    expiresAt: number;
  } | null;
};

export type DownloadContractMutationVariables = {
  accountId: string;
};

export type DownloadContractMutation = {
  downloadContract?: {
    __typename: 'DownloadFile';
    downloadUrl: string;
    expiresAt: number;
  } | null;
};

export type DisableUserMutationVariables = {
  id: string;
};

export type DisableUserMutation = {
  disableUser: {
    __typename: 'User';
    id: string;
    email: string;
    status: UserStatus;
    enabled: boolean;
    accountId?: string | null;
    testAccountId?: string | null;
    createdAt: string;
    locale?: string | null;
    referralCode?: string | null;
    promoCode?: string | null;
    emailVerified?: boolean | null;
    phoneNumber?: string | null;
    phoneNumberVerified?: boolean | null;
    smsMfaEnabled?: boolean | null;
  };
};

export type EnableUserMutationVariables = {
  id: string;
};

export type EnableUserMutation = {
  enableUser: {
    __typename: 'User';
    id: string;
    email: string;
    status: UserStatus;
    enabled: boolean;
    accountId?: string | null;
    testAccountId?: string | null;
    createdAt: string;
    locale?: string | null;
    referralCode?: string | null;
    promoCode?: string | null;
    emailVerified?: boolean | null;
    phoneNumber?: string | null;
    phoneNumberVerified?: boolean | null;
    smsMfaEnabled?: boolean | null;
  };
};

export type GenerateSettlementReportMutationVariables = {
  input: GenerateSettlementReportInput;
};

export type GenerateSettlementReportMutation = {
  generateSettlementReport: {
    __typename: 'DownloadFile';
    downloadUrl: string;
    expiresAt: number;
  };
};

export type DisableTokenizationMethodMutationVariables = {
  accountId: string;
  method: TokenizationMethods;
};

export type DisableTokenizationMethodMutation = {
  disableTokenizationMethod: {
    __typename: 'Account';
    id: string;
    name?: string | null;
    status: AccountStatus;
    reason?: string | null;
    note?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    riskScore?: number | null;
    timezone?: string | null;
    language?: string | null;
    paymentMethods?: {
      __typename: 'AccountPaymentMethods';
      CREDITCARD?: {
        __typename: 'AccountPaymentMethodsCreditCard';
        enabled?: boolean | null;
        allowPaymentDetails?: boolean | null;
        preauthorization?: boolean | null;
      } | null;
      BIZUM?: {
        __typename: 'AccountPaymentMethodsBizum';
        enabled?: boolean | null;
      } | null;
    } | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    representatives?: Array<{
      __typename: 'Representative';
      firstName?: string | null;
      lastName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      dateOfBirth?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      document?: {
        __typename: 'IdDocument';
        type?: string | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      idSession?: string | null;
      idSessionUrl?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusMessage?: string | null;
      statusCode?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      hasNoPublicActivity?: boolean | null;
      nationality?: string | null;
      citizenship?: string | null;
      registeredAt?: string | null;
      deletedAt?: string | null;
    }> | null;
    publicBusinessDetails?: {
      __typename: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      supportWebsite?: string | null;
      supportEmail?: string | null;
      supportPhone?: string | null;
    } | null;
    branding?: {
      __typename: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    iban?: string | null;
    fees?: {
      __typename: 'AccountFees';
      trxFee?: number | null;
      trxFlatFee?: number | null;
      highRiskFee?: number | null;
      dailyPlatformFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      extra?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      }> | null;
      steps?: Array<{
        __typename: 'AccountSteps';
        from: number;
        trxFee: number;
        trxFlatFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        multibancoTrxFee?: number | null;
        multibancoTrxFlatFee?: number | null;
      }> | null;
    } | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    dynamicBilling?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    tokenizationMethods?: {
      __typename: 'AccountTokenizationMethods';
      googlePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      applePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      clickToPay?: {
        __typename: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
        dpaId?: string | null;
      } | null;
    } | null;
    referralCode?: string | null;
    promoCode?: string | null;
    billingPlan?: BillingPlans | null;
    notifications?: {
      __typename: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
    } | null;
    contract?: {
      __typename: 'AccountContract';
      envelopeId: string;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    billingVatPercent?: number | null;
    allowCreateApiKey?: boolean | null;
    masterAccountId?: string | null;
    reviewConfirmed?: boolean | null;
    churned?: boolean | null;
  };
};

export type EnableTokenizationMethodMutationVariables = {
  accountId: string;
  method: TokenizationMethods;
};

export type EnableTokenizationMethodMutation = {
  enableTokenizationMethod: {
    __typename: 'Account';
    id: string;
    name?: string | null;
    status: AccountStatus;
    reason?: string | null;
    note?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    riskScore?: number | null;
    timezone?: string | null;
    language?: string | null;
    paymentMethods?: {
      __typename: 'AccountPaymentMethods';
      CREDITCARD?: {
        __typename: 'AccountPaymentMethodsCreditCard';
        enabled?: boolean | null;
        allowPaymentDetails?: boolean | null;
        preauthorization?: boolean | null;
      } | null;
      BIZUM?: {
        __typename: 'AccountPaymentMethodsBizum';
        enabled?: boolean | null;
      } | null;
    } | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    representatives?: Array<{
      __typename: 'Representative';
      firstName?: string | null;
      lastName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      dateOfBirth?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      document?: {
        __typename: 'IdDocument';
        type?: string | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      idSession?: string | null;
      idSessionUrl?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusMessage?: string | null;
      statusCode?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      hasNoPublicActivity?: boolean | null;
      nationality?: string | null;
      citizenship?: string | null;
      registeredAt?: string | null;
      deletedAt?: string | null;
    }> | null;
    publicBusinessDetails?: {
      __typename: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      supportWebsite?: string | null;
      supportEmail?: string | null;
      supportPhone?: string | null;
    } | null;
    branding?: {
      __typename: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    iban?: string | null;
    fees?: {
      __typename: 'AccountFees';
      trxFee?: number | null;
      trxFlatFee?: number | null;
      highRiskFee?: number | null;
      dailyPlatformFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      extra?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      }> | null;
      steps?: Array<{
        __typename: 'AccountSteps';
        from: number;
        trxFee: number;
        trxFlatFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        multibancoTrxFee?: number | null;
        multibancoTrxFlatFee?: number | null;
      }> | null;
    } | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    dynamicBilling?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    tokenizationMethods?: {
      __typename: 'AccountTokenizationMethods';
      googlePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      applePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      clickToPay?: {
        __typename: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
        dpaId?: string | null;
      } | null;
    } | null;
    referralCode?: string | null;
    promoCode?: string | null;
    billingPlan?: BillingPlans | null;
    notifications?: {
      __typename: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
    } | null;
    contract?: {
      __typename: 'AccountContract';
      envelopeId: string;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    billingVatPercent?: number | null;
    allowCreateApiKey?: boolean | null;
    masterAccountId?: string | null;
    reviewConfirmed?: boolean | null;
    churned?: boolean | null;
  };
};

export type CreateSubscriptionMutationVariables = {
  input: CreateSubscriptionInput;
};

export type CreateSubscriptionMutation = {
  createSubscription?: {
    __typename: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    lastPayment?: {
      __typename: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    } | null> | null;
    status: SubscriptionStatus;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
  } | null;
};

export type ActivateSubscriptionMutationVariables = {
  input: ActivateSubscriptionInput;
};

export type ActivateSubscriptionMutation = {
  activateSubscription?: {
    __typename: 'Payment';
    id: string;
    amount?: number | null;
    currency: string;
    orderId?: string | null;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    description?: string | null;
    accountId: string;
    authorizationCode?: string | null;
    livemode?: boolean | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    paymentToken?: string | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shop?: {
      __typename: 'Shop';
      name: string;
      country?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    sessionDetails?: {
      __typename: 'SessionDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    pageOpenedAt?: number | null;
    masterAccountId?: string | null;
  } | null;
};

export type UpdateSubscriptionMutationVariables = {
  input: UpdateSubscriptionInput;
};

export type UpdateSubscriptionMutation = {
  updateSubscription?: {
    __typename: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    lastPayment?: {
      __typename: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    } | null> | null;
    status: SubscriptionStatus;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
  } | null;
};

export type CancelSubscriptionMutationVariables = {
  input: CancelSubscriptionInput;
};

export type CancelSubscriptionMutation = {
  cancelSubscription?: {
    __typename: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    lastPayment?: {
      __typename: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    } | null> | null;
    status: SubscriptionStatus;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
  } | null;
};

export type PauseSubscriptionMutationVariables = {
  input: PauseSubscriptionInput;
};

export type PauseSubscriptionMutation = {
  pauseSubscription?: {
    __typename: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    lastPayment?: {
      __typename: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    } | null> | null;
    status: SubscriptionStatus;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
  } | null;
};

export type ResumeSubscriptionMutationVariables = {
  input: ResumeSubscriptionInput;
};

export type ResumeSubscriptionMutation = {
  resumeSubscription?: {
    __typename: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    lastPayment?: {
      __typename: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    } | null> | null;
    status: SubscriptionStatus;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
  } | null;
};

export type CreateMasterAccountMutationVariables = {
  input: CreateMasterAccountInput;
};

export type CreateMasterAccountMutation = {
  createMasterAccount: {
    __typename: 'MasterAccount';
    id: string;
    adminEmail?: string | null;
    apiKey?: string | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    contractTemplateId?: string | null;
    createdAt?: string | null;
    deletedAt?: string | null;
    extraFees?: Array<{
      __typename: 'AccountExtraFee';
      name: string;
      amount: number;
      type: AccountExtraFeeType;
      region?: AccountExtraFeeRegion | null;
      masterAccountFee?: boolean | null;
    } | null> | null;
    iban?: string | null;
    name?: string | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    promoCode?: string | null;
    status?: AccountStatus | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    updatedAt?: string | null;
    allowedIPs?: Array<string | null> | null;
    accountDefaults?: {
      __typename: 'AccountDefaults';
      billingPlan?: BillingPlans | null;
      iban?: string | null;
      payoutTerms?: {
        __typename: 'AccountPayoutTerms';
        iban?: string | null;
        firstPeriod?: number | null;
        period?: number | null;
        reservePercent?: number | null;
        suspended?: boolean | null;
        releaseReserve?: boolean | null;
      } | null;
      fees?: {
        __typename: 'AccountFees';
        trxFee?: number | null;
        trxFlatFee?: number | null;
        highRiskFee?: number | null;
        dailyPlatformFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        extra?: Array<{
          __typename: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          region?: AccountExtraFeeRegion | null;
          masterAccountFee?: boolean | null;
        }> | null;
        steps?: Array<{
          __typename: 'AccountSteps';
          from: number;
          trxFee: number;
          trxFlatFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          multibancoTrxFee?: number | null;
          multibancoTrxFlatFee?: number | null;
        }> | null;
      } | null;
      business?: {
        __typename: 'BusinessDefault';
        mcc?: string | null;
        website?: string | null;
        confirmWebsite?: boolean | null;
        servicesDescription?: string | null;
        confirmServicesDescription?: boolean | null;
      } | null;
      language?: string | null;
      notifications?: {
        __typename: 'AccountNotifications';
        emailCustomerOnRefund?: boolean | null;
        emailCustomerOnSuccess?: boolean | null;
        emailAdminOnSuccess?: boolean | null;
      } | null;
    } | null;
  };
};

export type UpdateMasterAccountMutationVariables = {
  input: UpdateMasterAccountInput;
};

export type UpdateMasterAccountMutation = {
  updateMasterAccount: {
    __typename: 'MasterAccount';
    id: string;
    adminEmail?: string | null;
    apiKey?: string | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    contractTemplateId?: string | null;
    createdAt?: string | null;
    deletedAt?: string | null;
    extraFees?: Array<{
      __typename: 'AccountExtraFee';
      name: string;
      amount: number;
      type: AccountExtraFeeType;
      region?: AccountExtraFeeRegion | null;
      masterAccountFee?: boolean | null;
    } | null> | null;
    iban?: string | null;
    name?: string | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    promoCode?: string | null;
    status?: AccountStatus | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    updatedAt?: string | null;
    allowedIPs?: Array<string | null> | null;
    accountDefaults?: {
      __typename: 'AccountDefaults';
      billingPlan?: BillingPlans | null;
      iban?: string | null;
      payoutTerms?: {
        __typename: 'AccountPayoutTerms';
        iban?: string | null;
        firstPeriod?: number | null;
        period?: number | null;
        reservePercent?: number | null;
        suspended?: boolean | null;
        releaseReserve?: boolean | null;
      } | null;
      fees?: {
        __typename: 'AccountFees';
        trxFee?: number | null;
        trxFlatFee?: number | null;
        highRiskFee?: number | null;
        dailyPlatformFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        extra?: Array<{
          __typename: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          region?: AccountExtraFeeRegion | null;
          masterAccountFee?: boolean | null;
        }> | null;
        steps?: Array<{
          __typename: 'AccountSteps';
          from: number;
          trxFee: number;
          trxFlatFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          multibancoTrxFee?: number | null;
          multibancoTrxFlatFee?: number | null;
        }> | null;
      } | null;
      business?: {
        __typename: 'BusinessDefault';
        mcc?: string | null;
        website?: string | null;
        confirmWebsite?: boolean | null;
        servicesDescription?: string | null;
        confirmServicesDescription?: boolean | null;
      } | null;
      language?: string | null;
      notifications?: {
        __typename: 'AccountNotifications';
        emailCustomerOnRefund?: boolean | null;
        emailCustomerOnSuccess?: boolean | null;
        emailAdminOnSuccess?: boolean | null;
      } | null;
    } | null;
  };
};

export type CreateDocumentMutationVariables = {
  input: CreateDocumentInput;
};

export type CreateDocumentMutation = {
  createDocument: {
    __typename: 'Document';
    id: string;
    accountId: string;
    type: DocumentType;
    status: DocumentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    contentType?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    name?: string | null;
    note?: string | null;
    internal?: boolean | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    metadata?: Array<{
      __typename: 'DocumentMetadataItem';
      key: string;
      value?: string | null;
    }> | null;
  };
};

export type UploadDocumentMutationVariables = {
  id: string;
  accountId: string;
  contentType?: string | null;
};

export type UploadDocumentMutation = {
  uploadDocument: {
    __typename: 'UploadFile';
    uploadUrl: string;
    expiresAt: number;
  };
};

export type DownloadDocumentMutationVariables = {
  id: string;
  accountId: string;
};

export type DownloadDocumentMutation = {
  downloadDocument: {
    __typename: 'DownloadFile';
    downloadUrl: string;
    expiresAt: number;
  };
};

export type DeleteDocumentMutationVariables = {
  id: string;
  accountId: string;
};

export type DeleteDocumentMutation = {
  deleteDocument: boolean;
};

export type PublishUpdateAnalyticsMutationVariables = {
  all: boolean;
};

export type PublishUpdateAnalyticsMutation = {
  publishUpdateAnalytics?: {
    __typename: 'AnalyticsChange';
    all?: boolean | null;
  } | null;
};

export type PublishUpdateEventsMutationVariables = {
  accountId: string;
};

export type PublishUpdateEventsMutation = {
  publishUpdateEvents?: {
    __typename: 'EventsChange';
    accountId?: string | null;
  } | null;
};

export type PublishUpdateDocumentsMutationVariables = {
  accountId: string;
};

export type PublishUpdateDocumentsMutation = {
  publishUpdateDocuments?: {
    __typename: 'DocumentsChange';
    accountId?: string | null;
  } | null;
};

export type SendPaymentLinkMutationVariables = {
  input: SendPaymentMessageInput;
};

export type SendPaymentLinkMutation = {
  sendPaymentLink?: {
    __typename: 'Payment';
    id: string;
    amount?: number | null;
    currency: string;
    orderId?: string | null;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    description?: string | null;
    accountId: string;
    authorizationCode?: string | null;
    livemode?: boolean | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    paymentToken?: string | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shop?: {
      __typename: 'Shop';
      name: string;
      country?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    sessionDetails?: {
      __typename: 'SessionDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    pageOpenedAt?: number | null;
    masterAccountId?: string | null;
  } | null;
};

export type SendPaymentRequestMutationVariables = {
  input: SendPaymentRequestInput;
};

export type SendPaymentRequestMutation = {
  sendPaymentRequest?: {
    __typename: 'Payment';
    id: string;
    amount?: number | null;
    currency: string;
    orderId?: string | null;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    description?: string | null;
    accountId: string;
    authorizationCode?: string | null;
    livemode?: boolean | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    paymentToken?: string | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shop?: {
      __typename: 'Shop';
      name: string;
      country?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    sessionDetails?: {
      __typename: 'SessionDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    pageOpenedAt?: number | null;
    masterAccountId?: string | null;
  } | null;
};

export type CreatePaymentMutationVariables = {
  input: CreatePaymentInput;
};

export type CreatePaymentMutation = {
  createPayment?: {
    __typename: 'Payment';
    id: string;
    amount?: number | null;
    currency: string;
    orderId?: string | null;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    description?: string | null;
    accountId: string;
    authorizationCode?: string | null;
    livemode?: boolean | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    paymentToken?: string | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shop?: {
      __typename: 'Shop';
      name: string;
      country?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    sessionDetails?: {
      __typename: 'SessionDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    pageOpenedAt?: number | null;
    masterAccountId?: string | null;
  } | null;
};

export type RefundPaymentMutationVariables = {
  input: RefundPaymentInput;
};

export type RefundPaymentMutation = {
  refundPayment?: {
    __typename: 'Payment';
    id: string;
    amount?: number | null;
    currency: string;
    orderId?: string | null;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    description?: string | null;
    accountId: string;
    authorizationCode?: string | null;
    livemode?: boolean | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    paymentToken?: string | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shop?: {
      __typename: 'Shop';
      name: string;
      country?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    sessionDetails?: {
      __typename: 'SessionDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    pageOpenedAt?: number | null;
    masterAccountId?: string | null;
  } | null;
};

export type CapturePaymentMutationVariables = {
  input: CapturePaymentInput;
};

export type CapturePaymentMutation = {
  capturePayment?: {
    __typename: 'Payment';
    id: string;
    amount?: number | null;
    currency: string;
    orderId?: string | null;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    description?: string | null;
    accountId: string;
    authorizationCode?: string | null;
    livemode?: boolean | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    paymentToken?: string | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shop?: {
      __typename: 'Shop';
      name: string;
      country?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    sessionDetails?: {
      __typename: 'SessionDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    pageOpenedAt?: number | null;
    masterAccountId?: string | null;
  } | null;
};

export type CancelPaymentMutationVariables = {
  input: CancelPaymentInput;
};

export type CancelPaymentMutation = {
  cancelPayment?: {
    __typename: 'Payment';
    id: string;
    amount?: number | null;
    currency: string;
    orderId?: string | null;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    description?: string | null;
    accountId: string;
    authorizationCode?: string | null;
    livemode?: boolean | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    paymentToken?: string | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shop?: {
      __typename: 'Shop';
      name: string;
      country?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    sessionDetails?: {
      __typename: 'SessionDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    pageOpenedAt?: number | null;
    masterAccountId?: string | null;
  } | null;
};

export type SendPaymentReceiptMutationVariables = {
  input: SendPaymentMessageInput;
};

export type SendPaymentReceiptMutation = {
  sendPaymentReceipt?: {
    __typename: 'Payment';
    id: string;
    amount?: number | null;
    currency: string;
    orderId?: string | null;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    description?: string | null;
    accountId: string;
    authorizationCode?: string | null;
    livemode?: boolean | null;
    status: PaymentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    paymentToken?: string | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    shop?: {
      __typename: 'Shop';
      name: string;
      country?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    refundedAmount?: number | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    cancellationReason?: CancellationReason | null;
    sessionDetails?: {
      __typename: 'SessionDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    nextAction?: {
      __typename: 'NextAction';
      type?: NextActionTypes | null;
      redirectUrl?: string | null;
      mustRedirect?: boolean | null;
    } | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    pageOpenedAt?: number | null;
    masterAccountId?: string | null;
  } | null;
};

export type AccountQueryVariables = {
  id: string;
};

export type AccountQuery = {
  account?: {
    __typename: 'Account';
    id: string;
    name?: string | null;
    status: AccountStatus;
    reason?: string | null;
    note?: string | null;
    partner?: Partner | null;
    acquirer?: Acquirer | null;
    adminEmail?: string | null;
    riskScore?: number | null;
    timezone?: string | null;
    language?: string | null;
    paymentMethods?: {
      __typename: 'AccountPaymentMethods';
      CREDITCARD?: {
        __typename: 'AccountPaymentMethodsCreditCard';
        enabled?: boolean | null;
        allowPaymentDetails?: boolean | null;
        preauthorization?: boolean | null;
      } | null;
      BIZUM?: {
        __typename: 'AccountPaymentMethodsBizum';
        enabled?: boolean | null;
      } | null;
    } | null;
    defaultCurrency?: Currencies | null;
    defaultTransactionType?: TransactionTypes | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    representatives?: Array<{
      __typename: 'Representative';
      firstName?: string | null;
      lastName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      email?: string | null;
      phone?: string | null;
      documentNumber?: string | null;
      stocksPercentage?: number | null;
      gender?: Gender | null;
      dateOfBirth?: string | null;
      yearOfBirth?: string | null;
      placeOfBirth?: string | null;
      document?: {
        __typename: 'IdDocument';
        type?: string | null;
        number?: string | null;
        country?: string | null;
        validFrom?: string | null;
        validUntil?: string | null;
      } | null;
      idSession?: string | null;
      idSessionUrl?: string | null;
      interventionType?: Array<InterventionType> | null;
      status?: IdVerificationStatus | null;
      statusMessage?: string | null;
      statusCode?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
      hasNoPublicActivity?: boolean | null;
      nationality?: string | null;
      citizenship?: string | null;
      registeredAt?: string | null;
      deletedAt?: string | null;
    }> | null;
    publicBusinessDetails?: {
      __typename: 'AccountPublicBusinessDetails';
      companyName?: string | null;
      website?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      supportWebsite?: string | null;
      supportEmail?: string | null;
      supportPhone?: string | null;
    } | null;
    branding?: {
      __typename: 'AccountBranding';
      accentColor?: string | null;
      bgColor?: string | null;
      logoUrl?: string | null;
      iconUrl?: string | null;
    } | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    iban?: string | null;
    fees?: {
      __typename: 'AccountFees';
      trxFee?: number | null;
      trxFlatFee?: number | null;
      highRiskFee?: number | null;
      dailyPlatformFee?: number | null;
      dailyExtraSeatsFee?: number | null;
      extra?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      }> | null;
      steps?: Array<{
        __typename: 'AccountSteps';
        from: number;
        trxFee: number;
        trxFlatFee: number;
        bizumTrxFee?: number | null;
        bizumTrxFlatFee?: number | null;
        multibancoTrxFee?: number | null;
        multibancoTrxFlatFee?: number | null;
      }> | null;
    } | null;
    test?: boolean | null;
    secret?: string | null;
    apiKey?: string | null;
    customDomain?: string | null;
    dynamicBilling?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    deletedAt?: string | null;
    approvedAt?: string | null;
    rejectedAt?: string | null;
    activatedAt?: string | null;
    approvalRequestedAt?: string | null;
    suspendedAt?: string | null;
    dataUpdatedAt?: string | null;
    tokenizationMethods?: {
      __typename: 'AccountTokenizationMethods';
      googlePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      applePay?: {
        __typename: 'AccountTokenizationMethodsItem';
        enabled?: boolean | null;
      } | null;
      clickToPay?: {
        __typename: 'AccountTokenizationMethodsClickToPayItem';
        enabled?: boolean | null;
        dpaId?: string | null;
      } | null;
    } | null;
    referralCode?: string | null;
    promoCode?: string | null;
    billingPlan?: BillingPlans | null;
    notifications?: {
      __typename: 'AccountNotifications';
      emailCustomerOnRefund?: boolean | null;
      emailCustomerOnSuccess?: boolean | null;
      emailAdminOnSuccess?: boolean | null;
    } | null;
    contract?: {
      __typename: 'AccountContract';
      envelopeId: string;
      status: ContractStatus;
      path?: string | null;
      signedDate?: string | null;
    } | null;
    billingVatPercent?: number | null;
    allowCreateApiKey?: boolean | null;
    masterAccountId?: string | null;
    reviewConfirmed?: boolean | null;
    churned?: boolean | null;
  } | null;
};

export type AccountsQueryVariables = {
  filter?: SearchableAccountFilterInput | null;
  size?: number | null;
  from?: number | null;
};

export type AccountsQuery = {
  accounts: {
    __typename: 'AccountsConnection';
    items: Array<{
      __typename: 'Account';
      id: string;
      name?: string | null;
      status: AccountStatus;
      reason?: string | null;
      note?: string | null;
      partner?: Partner | null;
      acquirer?: Acquirer | null;
      adminEmail?: string | null;
      riskScore?: number | null;
      timezone?: string | null;
      language?: string | null;
      paymentMethods?: {
        __typename: 'AccountPaymentMethods';
        CREDITCARD?: {
          __typename: 'AccountPaymentMethodsCreditCard';
          enabled?: boolean | null;
          allowPaymentDetails?: boolean | null;
          preauthorization?: boolean | null;
        } | null;
        BIZUM?: {
          __typename: 'AccountPaymentMethodsBizum';
          enabled?: boolean | null;
        } | null;
      } | null;
      defaultCurrency?: Currencies | null;
      defaultTransactionType?: TransactionTypes | null;
      business?: {
        __typename: 'BusinessData';
        country?: string | null;
        legalForm?: LegalForm | null;
        legalName?: string | null;
        companyName?: string | null;
        address?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        documentNumber?: string | null;
        email?: string | null;
        phone?: string | null;
        website?: string | null;
        monthlyVolume?: number | null;
        confirmWebsite?: boolean | null;
        industry?: Industries | null;
        mcc?: string | null;
        servicesDescription?: string | null;
        status?: BusinessStatus | null;
        confirmServicesDescription?: boolean | null;
        legalAddress?: string | null;
        legalDescription?: string | null;
        creationDate?: string | null;
        lastUpdateDate?: string | null;
        startActivityDate?: string | null;
        registryRecords?: Array<{
          __typename: 'RegistryRecord';
          name?: string | null;
          url?: string | null;
          province?: string | null;
          date?: string | null;
        }> | null;
        positions?: Array<{
          __typename: 'BusinessPosition';
          fromDate?: string | null;
          role?: string | null;
          name?: string | null;
        }> | null;
        capital?: string | null;
        previousNames?: Array<string | null> | null;
        verificationAttempts?: number | null;
        riskLabels?: Array<{
          __typename: 'RiskLabel';
          label?: string | null;
          category?: string | null;
        }> | null;
      } | null;
      representatives?: Array<{
        __typename: 'Representative';
        firstName?: string | null;
        lastName?: string | null;
        address?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        email?: string | null;
        phone?: string | null;
        documentNumber?: string | null;
        stocksPercentage?: number | null;
        gender?: Gender | null;
        dateOfBirth?: string | null;
        yearOfBirth?: string | null;
        placeOfBirth?: string | null;
        document?: {
          __typename: 'IdDocument';
          type?: string | null;
          number?: string | null;
          country?: string | null;
          validFrom?: string | null;
          validUntil?: string | null;
        } | null;
        idSession?: string | null;
        idSessionUrl?: string | null;
        interventionType?: Array<InterventionType> | null;
        status?: IdVerificationStatus | null;
        statusMessage?: string | null;
        statusCode?: number | null;
        riskLabels?: Array<{
          __typename: 'RiskLabel';
          label?: string | null;
          category?: string | null;
        }> | null;
        hasNoPublicActivity?: boolean | null;
        nationality?: string | null;
        citizenship?: string | null;
        registeredAt?: string | null;
        deletedAt?: string | null;
      }> | null;
      publicBusinessDetails?: {
        __typename: 'AccountPublicBusinessDetails';
        companyName?: string | null;
        website?: string | null;
        phone?: string | null;
        address?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        supportWebsite?: string | null;
        supportEmail?: string | null;
        supportPhone?: string | null;
      } | null;
      branding?: {
        __typename: 'AccountBranding';
        accentColor?: string | null;
        bgColor?: string | null;
        logoUrl?: string | null;
        iconUrl?: string | null;
      } | null;
      payoutTerms?: {
        __typename: 'AccountPayoutTerms';
        iban?: string | null;
        firstPeriod?: number | null;
        period?: number | null;
        reservePercent?: number | null;
        suspended?: boolean | null;
        releaseReserve?: boolean | null;
      } | null;
      iban?: string | null;
      fees?: {
        __typename: 'AccountFees';
        trxFee?: number | null;
        trxFlatFee?: number | null;
        highRiskFee?: number | null;
        dailyPlatformFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        extra?: Array<{
          __typename: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          region?: AccountExtraFeeRegion | null;
          masterAccountFee?: boolean | null;
        }> | null;
        steps?: Array<{
          __typename: 'AccountSteps';
          from: number;
          trxFee: number;
          trxFlatFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          multibancoTrxFee?: number | null;
          multibancoTrxFlatFee?: number | null;
        }> | null;
      } | null;
      test?: boolean | null;
      secret?: string | null;
      apiKey?: string | null;
      customDomain?: string | null;
      dynamicBilling?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      deletedAt?: string | null;
      approvedAt?: string | null;
      rejectedAt?: string | null;
      activatedAt?: string | null;
      approvalRequestedAt?: string | null;
      suspendedAt?: string | null;
      dataUpdatedAt?: string | null;
      tokenizationMethods?: {
        __typename: 'AccountTokenizationMethods';
        googlePay?: {
          __typename: 'AccountTokenizationMethodsItem';
          enabled?: boolean | null;
        } | null;
        applePay?: {
          __typename: 'AccountTokenizationMethodsItem';
          enabled?: boolean | null;
        } | null;
        clickToPay?: {
          __typename: 'AccountTokenizationMethodsClickToPayItem';
          enabled?: boolean | null;
          dpaId?: string | null;
        } | null;
      } | null;
      referralCode?: string | null;
      promoCode?: string | null;
      billingPlan?: BillingPlans | null;
      notifications?: {
        __typename: 'AccountNotifications';
        emailCustomerOnRefund?: boolean | null;
        emailCustomerOnSuccess?: boolean | null;
        emailAdminOnSuccess?: boolean | null;
      } | null;
      contract?: {
        __typename: 'AccountContract';
        envelopeId: string;
        status: ContractStatus;
        path?: string | null;
        signedDate?: string | null;
      } | null;
      billingVatPercent?: number | null;
      allowCreateApiKey?: boolean | null;
      masterAccountId?: string | null;
      reviewConfirmed?: boolean | null;
      churned?: boolean | null;
    }>;
    total: number;
  };
};

export type AccountActualFeesQueryVariables = {
  id: string;
};

export type AccountActualFeesQuery = {
  accountActualFees?: {
    __typename: 'AccountActualFees';
    highRiskFee: number;
    dailyPlatformFee: number;
    dailyExtraSeatsFee: number;
    extra?: Array<{
      __typename: 'AccountExtraFee';
      name: string;
      amount: number;
      type: AccountExtraFeeType;
      region?: AccountExtraFeeRegion | null;
      masterAccountFee?: boolean | null;
    }> | null;
    steps: Array<{
      __typename: 'AccountSteps';
      from: number;
      trxFee: number;
      trxFlatFee: number;
      bizumTrxFee?: number | null;
      bizumTrxFlatFee?: number | null;
      multibancoTrxFee?: number | null;
      multibancoTrxFlatFee?: number | null;
    }>;
  } | null;
};

export type ProviderQueryVariables = {
  id: string;
};

export type ProviderQuery = {
  provider?: {
    __typename: 'Provider';
    id: string;
    processor?: Processor | null;
    enabled?: boolean | null;
    test?: boolean | null;
    paymentMethod?: PaymentMethods | null;
    acquirer?: Acquirer | null;
    configurable?: boolean | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
    nativeHostedPayment?: boolean | null;
    rules?: {
      __typename: 'ProviderRules';
      minAmount?: number | null;
      maxAmount?: number | null;
      shopNameLike?: string | null;
      descriptionLike?: string | null;
    } | null;
  } | null;
};

export type ProvidersQueryVariables = {
  accountId: string;
};

export type ProvidersQuery = {
  providers?: Array<{
    __typename: 'Provider';
    id: string;
    processor?: Processor | null;
    enabled?: boolean | null;
    test?: boolean | null;
    paymentMethod?: PaymentMethods | null;
    acquirer?: Acquirer | null;
    configurable?: boolean | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
    nativeHostedPayment?: boolean | null;
    rules?: {
      __typename: 'ProviderRules';
      minAmount?: number | null;
      maxAmount?: number | null;
      shopNameLike?: string | null;
      descriptionLike?: string | null;
    } | null;
  }> | null;
};

export type AvailablePaymentMethodsQueryVariables = {
  accountId: string;
};

export type AvailablePaymentMethodsQuery = {
  availablePaymentMethods?: Array<{
    __typename: 'AvailablePaymentMethod';
    paymentMethod?: PaymentMethods | null;
    configured?: boolean | null;
    enabled?: boolean | null;
  }> | null;
};

export type AvailableProcessorsQueryVariables = {
  accountId: string;
  paymentMethod: PaymentMethods;
};

export type AvailableProcessorsQuery = {
  availableProcessors?: Array<{
    __typename: 'AvailableProcessor';
    paymentMethod?: PaymentMethods | null;
    processor?: Processor | null;
    configured?: boolean | null;
    configurable?: boolean | null;
    enabled?: boolean | null;
  }> | null;
};

export type ProviderConfigQueryVariables = {
  paymentMethod: PaymentMethods;
  processor: Processor;
};

export type ProviderConfigQuery = {
  providerConfig?: {
    __typename: 'ProviderConfig';
    paymentMethod?: PaymentMethods | null;
    processor?: Processor | null;
    acquirers?: Array<Acquirer> | null;
    metadataConfig?: Array<{
      __typename: 'MetadataConfigItem';
      key: string;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
  } | null;
};

export type StoreQueryVariables = {
  id: string;
};

export type StoreQuery = {
  store?: {
    __typename: 'Store';
    id: string;
    accountId: string;
    name?: string | null;
  } | null;
};

export type StoresQueryVariables = {
  accountId: string;
  token?: string | null;
  pageSize?: number | null;
};

export type StoresQuery = {
  stores: {
    __typename: 'StoresConnection';
    items: Array<{
      __typename: 'Store';
      id: string;
      accountId: string;
      name?: string | null;
    }>;
    nextToken?: string | null;
  };
};

export type PointOfSaleQueryVariables = {
  id: string;
};

export type PointOfSaleQuery = {
  pointOfSale?: {
    __typename: 'PointOfSale';
    id: string;
    accountId: string;
    storeId: string;
    number: number;
    name?: string | null;
    currentPaymentId?: string | null;
    manualAmount?: boolean | null;
  } | null;
};

export type PointsOfSaleQueryVariables = {
  accountId: string;
  storeId?: string | null;
  token?: string | null;
  pageSize?: number | null;
};

export type PointsOfSaleQuery = {
  pointsOfSale: {
    __typename: 'PointsOfSaleConnection';
    items: Array<{
      __typename: 'PointOfSale';
      id: string;
      accountId: string;
      storeId: string;
      number: number;
      name?: string | null;
      currentPaymentId?: string | null;
      manualAmount?: boolean | null;
    }>;
    nextToken?: string | null;
  };
};

export type CodeConfigQueryVariables = {
  codeType: CodeTypes;
};

export type CodeConfigQuery = {
  codeConfig?: {
    __typename: 'CodeConfig';
    metadataConfig?: Array<{
      __typename: 'MetadataConfigItem';
      key: string;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
  } | null;
};

export type CodeQueryVariables = {
  id: string;
};

export type CodeQuery = {
  code?: {
    __typename: 'Code';
    id: string;
    type: CodeTypes;
    enabled?: boolean | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
  } | null;
};

export type CodesQueryVariables = {
  accountId: string;
};

export type CodesQuery = {
  codes: Array<{
    __typename: 'Code';
    id: string;
    type: CodeTypes;
    enabled?: boolean | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    }> | null;
  }>;
};

export type ChargesQueryVariables = {
  filter?: SearchableChargeFilterInput | null;
  size?: number | null;
  from?: number | null;
};

export type ChargesQuery = {
  charges: {
    __typename: 'ChargesConnection';
    items: Array<{
      __typename: 'Charge';
      id: string;
      accountId: string;
      providerId?: string | null;
      checkoutId: string;
      providerReferenceId?: string | null;
      providerInternalId?: string | null;
      createdAt: number;
      updatedAt?: number | null;
      amount?: number | null;
      authorizationCode?: string | null;
      billingDetails?: {
        __typename: 'ContactDetails';
        email?: string | null;
        name?: string | null;
        company?: string | null;
        phone?: string | null;
        address?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      billingPlan?: BillingPlans | null;
      currency: string;
      customer?: {
        __typename: 'Customer';
        email?: string | null;
        name?: string | null;
        phone?: string | null;
      } | null;
      description?: string | null;
      livemode?: boolean | null;
      orderId?: string | null;
      storeId?: string | null;
      pointOfSaleId?: string | null;
      sequenceId?: string | null;
      subscriptionId?: string | null;
      acquirer?: Acquirer | null;
      processor?: Processor | null;
      paymentMethod?: {
        __typename: 'PaymentMethod';
        method?: PaymentMethods | null;
        bizum?: {
          __typename: 'PaymentMethodBizum';
          phoneNumber?: string | null;
          integrationType?: string | null;
        } | null;
        card?: {
          __typename: 'PaymentMethodCard';
          brand?: CardBrand | null;
          country?: string | null;
          type?: CardType | null;
          threeDSecure?: boolean | null;
          threeDSecureVersion?: string | null;
          threeDSecureFlow?: ThreeDSecureFlow | null;
          last4?: string | null;
          cardholderName?: string | null;
          cardholderEmail?: string | null;
          expiration?: number | null;
          bank?: string | null;
          tokenizationMethod?: TokenizationMethods | null;
          srcCorrelationId?: string | null;
          srciTransactionId?: string | null;
          srcDpaId?: string | null;
        } | null;
        cofidis?: {
          __typename: 'PaymentMethodCofidis';
          orderId?: string | null;
        } | null;
        cofidisLoan?: {
          __typename: 'PaymentMethodCofidisLoan';
          orderId?: string | null;
        } | null;
        mbway?: {
          __typename: 'PaymentMethodMBWay';
          phoneNumber?: string | null;
        } | null;
        paypal?: {
          __typename: 'PaymentMethodPaypal';
          orderId?: string | null;
          payerId?: string | null;
          email?: string | null;
          name?: string | null;
        } | null;
        sepa?: {
          __typename: 'PaymentMethodSepa';
          accountholderAddress?: {
            __typename: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
          accountholderEmail?: string | null;
          accountholderName?: string | null;
          countryCode?: string | null;
          bankAddress?: string | null;
          bankCode?: string | null;
          bankName?: string | null;
          bic?: string | null;
          last4?: string | null;
        } | null;
        trustly?: {
          __typename: 'PaymentMethodTrustly';
          customerId?: string | null;
        } | null;
        klarna?: {
          __typename: 'PaymentMethodKlarna';
          billingCategory?: BillingCategoryKlarna | null;
          authPaymentMethod?: AuthPaymentMethodKlarna | null;
        } | null;
      } | null;
      cancellationReason?: CancellationReason | null;
      lastRefundAmount?: number | null;
      lastRefundReason?: RefundReason | null;
      refundedAmount?: number | null;
      shippingDetails?: {
        __typename: 'ContactDetails';
        email?: string | null;
        name?: string | null;
        company?: string | null;
        phone?: string | null;
        address?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      shop?: {
        __typename: 'Shop';
        name: string;
        country?: string | null;
      } | null;
      status: ChargeStatus;
      statusCode?: string | null;
      statusMessage?: string | null;
      providerStatusCode?: string | null;
      providerStatusMessage?: string | null;
      issuerStatusCode?: string | null;
      issuerStatusMessage?: string | null;
      sessionDetails?: {
        __typename: 'SessionDetails';
        ip?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        browserColorDepth?: string | null;
        browserScreenHeight?: string | null;
        browserScreenWidth?: string | null;
        browserTimezoneOffset?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
      } | null;
      traceDetails?: {
        __typename: 'TraceDetails';
        ip?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
        userId?: string | null;
        userEmail?: string | null;
        userName?: string | null;
      } | null;
      pageOpenedAt?: number | null;
      masterAccountId?: string | null;
    }>;
    total: number;
  };
};

export type EventsQueryVariables = {
  filter?: SearchableEventFilterInput | null;
  size?: number | null;
  from?: number | null;
};

export type EventsQuery = {
  events: {
    __typename: 'ChargeEventsConnection';
    items: Array<{
      __typename: 'ChargeEvent';
      id: string;
      type: string;
      accountId: string;
      livemode?: boolean | null;
      objectId: string;
      objectType: string;
      object: {
        __typename: 'ChargeEventObject';
        id: string;
        accountId: string;
        providerId?: string | null;
        checkoutId: string;
        providerReferenceId?: string | null;
        providerInternalId?: string | null;
        createdAt?: number | null;
        updatedAt?: number | null;
        amount?: number | null;
        authorizationCode?: string | null;
        billingDetails?: {
          __typename: 'ContactDetails';
          email?: string | null;
          name?: string | null;
          company?: string | null;
          phone?: string | null;
          address?: {
            __typename: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        billingPlan?: BillingPlans | null;
        currency: string;
        customer?: {
          __typename: 'Customer';
          email?: string | null;
          name?: string | null;
          phone?: string | null;
        } | null;
        description?: string | null;
        livemode?: boolean | null;
        orderId?: string | null;
        storeId?: string | null;
        pointOfSaleId?: string | null;
        sequenceId?: string | null;
        subscriptionId?: string | null;
        paymentMethod?: {
          __typename: 'PaymentMethod';
          method?: PaymentMethods | null;
          bizum?: {
            __typename: 'PaymentMethodBizum';
            phoneNumber?: string | null;
            integrationType?: string | null;
          } | null;
          card?: {
            __typename: 'PaymentMethodCard';
            brand?: CardBrand | null;
            country?: string | null;
            type?: CardType | null;
            threeDSecure?: boolean | null;
            threeDSecureVersion?: string | null;
            threeDSecureFlow?: ThreeDSecureFlow | null;
            last4?: string | null;
            cardholderName?: string | null;
            cardholderEmail?: string | null;
            expiration?: number | null;
            bank?: string | null;
            tokenizationMethod?: TokenizationMethods | null;
            srcCorrelationId?: string | null;
            srciTransactionId?: string | null;
            srcDpaId?: string | null;
          } | null;
          cofidis?: {
            __typename: 'PaymentMethodCofidis';
            orderId?: string | null;
          } | null;
          cofidisLoan?: {
            __typename: 'PaymentMethodCofidisLoan';
            orderId?: string | null;
          } | null;
          mbway?: {
            __typename: 'PaymentMethodMBWay';
            phoneNumber?: string | null;
          } | null;
          paypal?: {
            __typename: 'PaymentMethodPaypal';
            orderId?: string | null;
            payerId?: string | null;
            email?: string | null;
            name?: string | null;
          } | null;
          sepa?: {
            __typename: 'PaymentMethodSepa';
            accountholderEmail?: string | null;
            accountholderName?: string | null;
            countryCode?: string | null;
            bankAddress?: string | null;
            bankCode?: string | null;
            bankName?: string | null;
            bic?: string | null;
            last4?: string | null;
          } | null;
          trustly?: {
            __typename: 'PaymentMethodTrustly';
            customerId?: string | null;
          } | null;
          klarna?: {
            __typename: 'PaymentMethodKlarna';
            billingCategory?: BillingCategoryKlarna | null;
            authPaymentMethod?: AuthPaymentMethodKlarna | null;
          } | null;
        } | null;
        cancellationReason?: CancellationReason | null;
        lastRefundAmount?: number | null;
        lastRefundReason?: RefundReason | null;
        refundedAmount?: number | null;
        shippingDetails?: {
          __typename: 'ContactDetails';
          email?: string | null;
          name?: string | null;
          company?: string | null;
          phone?: string | null;
          address?: {
            __typename: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        shop?: {
          __typename: 'Shop';
          name: string;
          country?: string | null;
        } | null;
        status: ChargeStatus;
        statusCode?: string | null;
        statusMessage?: string | null;
        providerStatusCode?: string | null;
        providerStatusMessage?: string | null;
        issuerStatusCode?: string | null;
        issuerStatusMessage?: string | null;
        sessionDetails?: {
          __typename: 'SessionDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          browserColorDepth?: string | null;
          browserScreenHeight?: string | null;
          browserScreenWidth?: string | null;
          browserTimezoneOffset?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
        } | null;
        traceDetails?: {
          __typename: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
        pageOpenedAt?: number | null;
        masterAccountId?: string | null;
      };
      createdAt?: number | null;
    }>;
    total: number;
  };
};

export type ChargeEventsQueryVariables = {
  chargeId: string;
  size?: number | null;
  from?: number | null;
};

export type ChargeEventsQuery = {
  chargeEvents: {
    __typename: 'ChargeEventsConnection';
    items: Array<{
      __typename: 'ChargeEvent';
      id: string;
      type: string;
      accountId: string;
      livemode?: boolean | null;
      objectId: string;
      objectType: string;
      object: {
        __typename: 'ChargeEventObject';
        id: string;
        accountId: string;
        providerId?: string | null;
        checkoutId: string;
        providerReferenceId?: string | null;
        providerInternalId?: string | null;
        createdAt?: number | null;
        updatedAt?: number | null;
        amount?: number | null;
        authorizationCode?: string | null;
        billingDetails?: {
          __typename: 'ContactDetails';
          email?: string | null;
          name?: string | null;
          company?: string | null;
          phone?: string | null;
          address?: {
            __typename: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        billingPlan?: BillingPlans | null;
        currency: string;
        customer?: {
          __typename: 'Customer';
          email?: string | null;
          name?: string | null;
          phone?: string | null;
        } | null;
        description?: string | null;
        livemode?: boolean | null;
        orderId?: string | null;
        storeId?: string | null;
        pointOfSaleId?: string | null;
        sequenceId?: string | null;
        subscriptionId?: string | null;
        paymentMethod?: {
          __typename: 'PaymentMethod';
          method?: PaymentMethods | null;
          bizum?: {
            __typename: 'PaymentMethodBizum';
            phoneNumber?: string | null;
            integrationType?: string | null;
          } | null;
          card?: {
            __typename: 'PaymentMethodCard';
            brand?: CardBrand | null;
            country?: string | null;
            type?: CardType | null;
            threeDSecure?: boolean | null;
            threeDSecureVersion?: string | null;
            threeDSecureFlow?: ThreeDSecureFlow | null;
            last4?: string | null;
            cardholderName?: string | null;
            cardholderEmail?: string | null;
            expiration?: number | null;
            bank?: string | null;
            tokenizationMethod?: TokenizationMethods | null;
            srcCorrelationId?: string | null;
            srciTransactionId?: string | null;
            srcDpaId?: string | null;
          } | null;
          cofidis?: {
            __typename: 'PaymentMethodCofidis';
            orderId?: string | null;
          } | null;
          cofidisLoan?: {
            __typename: 'PaymentMethodCofidisLoan';
            orderId?: string | null;
          } | null;
          mbway?: {
            __typename: 'PaymentMethodMBWay';
            phoneNumber?: string | null;
          } | null;
          paypal?: {
            __typename: 'PaymentMethodPaypal';
            orderId?: string | null;
            payerId?: string | null;
            email?: string | null;
            name?: string | null;
          } | null;
          sepa?: {
            __typename: 'PaymentMethodSepa';
            accountholderEmail?: string | null;
            accountholderName?: string | null;
            countryCode?: string | null;
            bankAddress?: string | null;
            bankCode?: string | null;
            bankName?: string | null;
            bic?: string | null;
            last4?: string | null;
          } | null;
          trustly?: {
            __typename: 'PaymentMethodTrustly';
            customerId?: string | null;
          } | null;
          klarna?: {
            __typename: 'PaymentMethodKlarna';
            billingCategory?: BillingCategoryKlarna | null;
            authPaymentMethod?: AuthPaymentMethodKlarna | null;
          } | null;
        } | null;
        cancellationReason?: CancellationReason | null;
        lastRefundAmount?: number | null;
        lastRefundReason?: RefundReason | null;
        refundedAmount?: number | null;
        shippingDetails?: {
          __typename: 'ContactDetails';
          email?: string | null;
          name?: string | null;
          company?: string | null;
          phone?: string | null;
          address?: {
            __typename: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
        } | null;
        shop?: {
          __typename: 'Shop';
          name: string;
          country?: string | null;
        } | null;
        status: ChargeStatus;
        statusCode?: string | null;
        statusMessage?: string | null;
        providerStatusCode?: string | null;
        providerStatusMessage?: string | null;
        issuerStatusCode?: string | null;
        issuerStatusMessage?: string | null;
        sessionDetails?: {
          __typename: 'SessionDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          browserColorDepth?: string | null;
          browserScreenHeight?: string | null;
          browserScreenWidth?: string | null;
          browserTimezoneOffset?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
        } | null;
        traceDetails?: {
          __typename: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
        pageOpenedAt?: number | null;
        masterAccountId?: string | null;
      };
      createdAt?: number | null;
    }>;
    total: number;
  };
};

export type AccountEventsQueryVariables = {
  accountId: string;
  size?: number | null;
  from?: number | null;
};

export type AccountEventsQuery = {
  accountEvents: {
    __typename: 'AccountEventsConnection';
    items: Array<{
      __typename: 'AccountEvent';
      id: string;
      type: string;
      accountId: string;
      livemode?: boolean | null;
      objectId: string;
      objectType: string;
      object: {
        __typename: 'AccountEventObject';
        id: string;
        name?: string | null;
        status: AccountStatus;
        reason?: string | null;
        note?: string | null;
        partner?: Partner | null;
        acquirer?: Acquirer | null;
        adminEmail?: string | null;
        riskScore?: number | null;
        timezone?: string | null;
        language?: string | null;
        paymentMethods?: {
          __typename: 'AccountPaymentMethods';
          CREDITCARD?: {
            __typename: 'AccountPaymentMethodsCreditCard';
            enabled?: boolean | null;
            allowPaymentDetails?: boolean | null;
            preauthorization?: boolean | null;
          } | null;
          BIZUM?: {
            __typename: 'AccountPaymentMethodsBizum';
            enabled?: boolean | null;
          } | null;
        } | null;
        defaultCurrency?: Currencies | null;
        defaultTransactionType?: TransactionTypes | null;
        business?: {
          __typename: 'BusinessData';
          country?: string | null;
          legalForm?: LegalForm | null;
          legalName?: string | null;
          companyName?: string | null;
          address?: {
            __typename: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
          documentNumber?: string | null;
          email?: string | null;
          phone?: string | null;
          website?: string | null;
          monthlyVolume?: number | null;
          confirmWebsite?: boolean | null;
          industry?: Industries | null;
          mcc?: string | null;
          servicesDescription?: string | null;
          status?: BusinessStatus | null;
          confirmServicesDescription?: boolean | null;
          legalAddress?: string | null;
          legalDescription?: string | null;
          creationDate?: string | null;
          lastUpdateDate?: string | null;
          startActivityDate?: string | null;
          registryRecords?: Array<{
            __typename: 'RegistryRecord';
            name?: string | null;
            url?: string | null;
            province?: string | null;
            date?: string | null;
          }> | null;
          positions?: Array<{
            __typename: 'BusinessPosition';
            fromDate?: string | null;
            role?: string | null;
            name?: string | null;
          }> | null;
          capital?: string | null;
          previousNames?: Array<string | null> | null;
          verificationAttempts?: number | null;
          riskLabels?: Array<{
            __typename: 'RiskLabel';
            label?: string | null;
            category?: string | null;
          }> | null;
        } | null;
        representatives?: Array<{
          __typename: 'Representative';
          firstName?: string | null;
          lastName?: string | null;
          address?: {
            __typename: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
          email?: string | null;
          phone?: string | null;
          documentNumber?: string | null;
          stocksPercentage?: number | null;
          gender?: Gender | null;
          dateOfBirth?: string | null;
          yearOfBirth?: string | null;
          placeOfBirth?: string | null;
          document?: {
            __typename: 'IdDocument';
            type?: string | null;
            number?: string | null;
            country?: string | null;
            validFrom?: string | null;
            validUntil?: string | null;
          } | null;
          idSession?: string | null;
          idSessionUrl?: string | null;
          interventionType?: Array<InterventionType> | null;
          status?: IdVerificationStatus | null;
          statusMessage?: string | null;
          statusCode?: number | null;
          riskLabels?: Array<{
            __typename: 'RiskLabel';
            label?: string | null;
            category?: string | null;
          }> | null;
          hasNoPublicActivity?: boolean | null;
          nationality?: string | null;
          citizenship?: string | null;
          registeredAt?: string | null;
          deletedAt?: string | null;
        }> | null;
        publicBusinessDetails?: {
          __typename: 'AccountPublicBusinessDetails';
          companyName?: string | null;
          website?: string | null;
          phone?: string | null;
          address?: {
            __typename: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
          supportWebsite?: string | null;
          supportEmail?: string | null;
          supportPhone?: string | null;
        } | null;
        branding?: {
          __typename: 'AccountBranding';
          accentColor?: string | null;
          bgColor?: string | null;
          logoUrl?: string | null;
          iconUrl?: string | null;
        } | null;
        payoutTerms?: {
          __typename: 'AccountPayoutTerms';
          iban?: string | null;
          firstPeriod?: number | null;
          period?: number | null;
          reservePercent?: number | null;
          suspended?: boolean | null;
          releaseReserve?: boolean | null;
        } | null;
        iban?: string | null;
        fees?: {
          __typename: 'AccountFees';
          trxFee?: number | null;
          trxFlatFee?: number | null;
          highRiskFee?: number | null;
          dailyPlatformFee?: number | null;
          dailyExtraSeatsFee?: number | null;
          extra?: Array<{
            __typename: 'AccountExtraFee';
            name: string;
            amount: number;
            type: AccountExtraFeeType;
            region?: AccountExtraFeeRegion | null;
            masterAccountFee?: boolean | null;
          }> | null;
          steps?: Array<{
            __typename: 'AccountSteps';
            from: number;
            trxFee: number;
            trxFlatFee: number;
            bizumTrxFee?: number | null;
            bizumTrxFlatFee?: number | null;
            multibancoTrxFee?: number | null;
            multibancoTrxFlatFee?: number | null;
          }> | null;
        } | null;
        test?: boolean | null;
        customDomain?: string | null;
        dynamicBilling?: boolean | null;
        tokenizationMethods?: {
          __typename: 'AccountTokenizationMethods';
          googlePay?: {
            __typename: 'AccountTokenizationMethodsItem';
            enabled?: boolean | null;
          } | null;
          applePay?: {
            __typename: 'AccountTokenizationMethodsItem';
            enabled?: boolean | null;
          } | null;
          clickToPay?: {
            __typename: 'AccountTokenizationMethodsClickToPayItem';
            enabled?: boolean | null;
            dpaId?: string | null;
          } | null;
        } | null;
        referralCode?: string | null;
        promoCode?: string | null;
        billingPlan?: BillingPlans | null;
        notifications?: {
          __typename: 'AccountNotifications';
          emailCustomerOnRefund?: boolean | null;
          emailCustomerOnSuccess?: boolean | null;
          emailAdminOnSuccess?: boolean | null;
        } | null;
        contract?: {
          __typename: 'AccountContract';
          envelopeId: string;
          status: ContractStatus;
          path?: string | null;
          signedDate?: string | null;
        } | null;
        createdAt?: string | null;
        updatedAt?: string | null;
        deletedAt?: string | null;
        approvedAt?: string | null;
        rejectedAt?: string | null;
        activatedAt?: string | null;
        approvalRequestedAt?: string | null;
        suspendedAt?: string | null;
        dataUpdatedAt?: string | null;
        traceDetails?: {
          __typename: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
        billingVatPercent?: number | null;
        allowCreateApiKey?: boolean | null;
        masterAccountId?: string | null;
        reviewConfirmed?: boolean | null;
        churned?: boolean | null;
      };
      createdAt?: number | null;
    }>;
    total: number;
  };
};

export type AccountStatsQueryVariables = {
  accountId: string;
};

export type AccountStatsQuery = {
  accountStats: {
    __typename: 'AccountStats';
    accountId: string;
    stats?: {
      __typename: 'Stats';
      firstTransactionAt?: string | null;
      activeMonths?: number | null;
      avgMonthlyTransactions?: number | null;
      avgMonthlyVolume?: number | null;
      churned?: boolean | null;
      totalSucceededCount?: number | null;
      lastTransactionAt?: string | null;
      totalSucceededAmount?: number | null;
    } | null;
  };
};

export type ChargeQueryVariables = {
  id: string;
};

export type ChargeQuery = {
  charge?: {
    __typename: 'Charge';
    id: string;
    accountId: string;
    providerId?: string | null;
    checkoutId: string;
    providerReferenceId?: string | null;
    providerInternalId?: string | null;
    createdAt: number;
    updatedAt?: number | null;
    amount?: number | null;
    authorizationCode?: string | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    billingPlan?: BillingPlans | null;
    currency: string;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    description?: string | null;
    livemode?: boolean | null;
    orderId?: string | null;
    storeId?: string | null;
    pointOfSaleId?: string | null;
    sequenceId?: string | null;
    subscriptionId?: string | null;
    acquirer?: Acquirer | null;
    processor?: Processor | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    cancellationReason?: CancellationReason | null;
    lastRefundAmount?: number | null;
    lastRefundReason?: RefundReason | null;
    refundedAmount?: number | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shop?: {
      __typename: 'Shop';
      name: string;
      country?: string | null;
    } | null;
    status: ChargeStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    providerStatusCode?: string | null;
    providerStatusMessage?: string | null;
    issuerStatusCode?: string | null;
    issuerStatusMessage?: string | null;
    sessionDetails?: {
      __typename: 'SessionDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      browserColorDepth?: string | null;
      browserScreenHeight?: string | null;
      browserScreenWidth?: string | null;
      browserTimezoneOffset?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
    } | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    pageOpenedAt?: number | null;
    masterAccountId?: string | null;
  } | null;
};

export type SubscriptionQueryVariables = {
  id: string;
};

export type SubscriptionQuery = {
  subscription?: {
    __typename: 'Subscription';
    id: string;
    accountId: string;
    livemode: boolean;
    amount: number;
    currency?: Currencies | null;
    description?: string | null;
    planVariantId?: string | null;
    productId?: string | null;
    cancelAtPeriodEnd?: boolean | null;
    pauseIntervalCount?: number | null;
    pauseAtPeriodEnd?: boolean | null;
    currentPeriodStart?: number | null;
    currentPeriodEnd?: number | null;
    trialPeriodDays?: number | null;
    trialPeriodEnd?: number | null;
    customerId?: string | null;
    customer?: {
      __typename: 'Customer';
      email?: string | null;
      name?: string | null;
      phone?: string | null;
    } | null;
    billingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    shippingDetails?: {
      __typename: 'ContactDetails';
      email?: string | null;
      name?: string | null;
      company?: string | null;
      phone?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
    } | null;
    defaultTokenId?: string | null;
    sequenceId?: string | null;
    lastInvoiceId?: string | null;
    lastOrderId?: string | null;
    lastPayment?: {
      __typename: 'LastPayment';
      id: string;
      status: PaymentStatus;
      statusMessage?: string | null;
      statusCode?: string | null;
    } | null;
    paymentMethod?: {
      __typename: 'PaymentMethod';
      method?: PaymentMethods | null;
      bizum?: {
        __typename: 'PaymentMethodBizum';
        phoneNumber?: string | null;
        integrationType?: string | null;
      } | null;
      card?: {
        __typename: 'PaymentMethodCard';
        brand?: CardBrand | null;
        country?: string | null;
        type?: CardType | null;
        threeDSecure?: boolean | null;
        threeDSecureVersion?: string | null;
        threeDSecureFlow?: ThreeDSecureFlow | null;
        last4?: string | null;
        cardholderName?: string | null;
        cardholderEmail?: string | null;
        expiration?: number | null;
        bank?: string | null;
        tokenizationMethod?: TokenizationMethods | null;
        srcCorrelationId?: string | null;
        srciTransactionId?: string | null;
        srcDpaId?: string | null;
      } | null;
      cofidis?: {
        __typename: 'PaymentMethodCofidis';
        orderId?: string | null;
      } | null;
      cofidisLoan?: {
        __typename: 'PaymentMethodCofidisLoan';
        orderId?: string | null;
      } | null;
      mbway?: {
        __typename: 'PaymentMethodMBWay';
        phoneNumber?: string | null;
      } | null;
      paypal?: {
        __typename: 'PaymentMethodPaypal';
        orderId?: string | null;
        payerId?: string | null;
        email?: string | null;
        name?: string | null;
      } | null;
      sepa?: {
        __typename: 'PaymentMethodSepa';
        accountholderAddress?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        accountholderEmail?: string | null;
        accountholderName?: string | null;
        countryCode?: string | null;
        bankAddress?: string | null;
        bankCode?: string | null;
        bankName?: string | null;
        bic?: string | null;
        last4?: string | null;
      } | null;
      trustly?: {
        __typename: 'PaymentMethodTrustly';
        customerId?: string | null;
      } | null;
      klarna?: {
        __typename: 'PaymentMethodKlarna';
        billingCategory?: BillingCategoryKlarna | null;
        authPaymentMethod?: AuthPaymentMethodKlarna | null;
      } | null;
    } | null;
    nextPaymentAt?: number | null;
    createdAt?: number | null;
    updatedAt?: number | null;
    interval: Interval;
    intervalCount: number;
    retryCount?: number | null;
    metadata?: Array<{
      __typename: 'MetadataItem';
      key: string;
      value?: string | null;
      type: MetadataItemType;
      label?: string | null;
      possibleValues?: Array<string> | null;
      regex?: string | null;
      secret?: boolean | null;
      required?: boolean | null;
      default?: string | null;
      example?: string | null;
      internal?: boolean | null;
    } | null> | null;
    status: SubscriptionStatus;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    callbackUrl?: string | null;
    paymentCallbackUrl?: string | null;
    storeId?: string | null;
    masterAccountId?: string | null;
  } | null;
};

export type SubscriptionsQueryVariables = {
  filter?: SearchableSubscriptionFilterInput | null;
  size?: number | null;
  from?: number | null;
};

export type SubscriptionsQuery = {
  subscriptions: {
    __typename: 'SubscriptionsConnection';
    items: Array<{
      __typename: 'Subscription';
      id: string;
      accountId: string;
      livemode: boolean;
      amount: number;
      currency?: Currencies | null;
      description?: string | null;
      planVariantId?: string | null;
      productId?: string | null;
      cancelAtPeriodEnd?: boolean | null;
      pauseIntervalCount?: number | null;
      pauseAtPeriodEnd?: boolean | null;
      currentPeriodStart?: number | null;
      currentPeriodEnd?: number | null;
      trialPeriodDays?: number | null;
      trialPeriodEnd?: number | null;
      customerId?: string | null;
      customer?: {
        __typename: 'Customer';
        email?: string | null;
        name?: string | null;
        phone?: string | null;
      } | null;
      billingDetails?: {
        __typename: 'ContactDetails';
        email?: string | null;
        name?: string | null;
        company?: string | null;
        phone?: string | null;
        address?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      shippingDetails?: {
        __typename: 'ContactDetails';
        email?: string | null;
        name?: string | null;
        company?: string | null;
        phone?: string | null;
        address?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
      } | null;
      defaultTokenId?: string | null;
      sequenceId?: string | null;
      lastInvoiceId?: string | null;
      lastOrderId?: string | null;
      lastPayment?: {
        __typename: 'LastPayment';
        id: string;
        status: PaymentStatus;
        statusMessage?: string | null;
        statusCode?: string | null;
      } | null;
      paymentMethod?: {
        __typename: 'PaymentMethod';
        method?: PaymentMethods | null;
        bizum?: {
          __typename: 'PaymentMethodBizum';
          phoneNumber?: string | null;
          integrationType?: string | null;
        } | null;
        card?: {
          __typename: 'PaymentMethodCard';
          brand?: CardBrand | null;
          country?: string | null;
          type?: CardType | null;
          threeDSecure?: boolean | null;
          threeDSecureVersion?: string | null;
          threeDSecureFlow?: ThreeDSecureFlow | null;
          last4?: string | null;
          cardholderName?: string | null;
          cardholderEmail?: string | null;
          expiration?: number | null;
          bank?: string | null;
          tokenizationMethod?: TokenizationMethods | null;
          srcCorrelationId?: string | null;
          srciTransactionId?: string | null;
          srcDpaId?: string | null;
        } | null;
        cofidis?: {
          __typename: 'PaymentMethodCofidis';
          orderId?: string | null;
        } | null;
        cofidisLoan?: {
          __typename: 'PaymentMethodCofidisLoan';
          orderId?: string | null;
        } | null;
        mbway?: {
          __typename: 'PaymentMethodMBWay';
          phoneNumber?: string | null;
        } | null;
        paypal?: {
          __typename: 'PaymentMethodPaypal';
          orderId?: string | null;
          payerId?: string | null;
          email?: string | null;
          name?: string | null;
        } | null;
        sepa?: {
          __typename: 'PaymentMethodSepa';
          accountholderAddress?: {
            __typename: 'Address';
            city?: string | null;
            country?: string | null;
            line1?: string | null;
            line2?: string | null;
            zip?: string | null;
            state?: string | null;
          } | null;
          accountholderEmail?: string | null;
          accountholderName?: string | null;
          countryCode?: string | null;
          bankAddress?: string | null;
          bankCode?: string | null;
          bankName?: string | null;
          bic?: string | null;
          last4?: string | null;
        } | null;
        trustly?: {
          __typename: 'PaymentMethodTrustly';
          customerId?: string | null;
        } | null;
        klarna?: {
          __typename: 'PaymentMethodKlarna';
          billingCategory?: BillingCategoryKlarna | null;
          authPaymentMethod?: AuthPaymentMethodKlarna | null;
        } | null;
      } | null;
      nextPaymentAt?: number | null;
      createdAt?: number | null;
      updatedAt?: number | null;
      interval: Interval;
      intervalCount: number;
      retryCount?: number | null;
      metadata?: Array<{
        __typename: 'MetadataItem';
        key: string;
        value?: string | null;
        type: MetadataItemType;
        label?: string | null;
        possibleValues?: Array<string> | null;
        regex?: string | null;
        secret?: boolean | null;
        required?: boolean | null;
        default?: string | null;
        example?: string | null;
        internal?: boolean | null;
      } | null> | null;
      status: SubscriptionStatus;
      traceDetails?: {
        __typename: 'TraceDetails';
        ip?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
        userId?: string | null;
        userEmail?: string | null;
        userName?: string | null;
      } | null;
      callbackUrl?: string | null;
      paymentCallbackUrl?: string | null;
      storeId?: string | null;
      masterAccountId?: string | null;
    }>;
    total: number;
  };
};

export type CountriesQuery = {
  countries: {
    __typename: 'Countries';
    supportedCountries: Array<{
      __typename: 'Country';
      name: string;
      phoneCode: string;
      code: string;
    }>;
    currentCountry?: {
      __typename: 'Country';
      name: string;
      phoneCode: string;
      code: string;
    } | null;
    currentCountryCode?: string | null;
    isSupported: boolean;
  };
};

export type ChargesDateRangeKPIQueryVariables = {
  start?: number | null;
  end?: number | null;
  interval?: Interval | null;
  accountId?: string | null;
  acquirer?: Acquirer | null;
  masterAccountId?: string | null;
  billingPlan?: string | null;
  paymentMethod?: PaymentMethods | null;
  source?: string | null;
  timezone?: string | null;
};

export type ChargesDateRangeKPIQuery = {
  chargesDateRangeKPI: {
    __typename: 'ChargesDateRangeKPI';
    currency: string;
    total: {
      __typename: 'ChargesDateRangeKPITotal';
      succeededAmount: string;
      succeededCount: string;
      capturedAmount: string;
      capturedCount: string;
      directAmount: string;
      directCount: string;
      canceledAmount: string;
      canceledCount: string;
      refundedAmount: string;
      refundedCount: string;
      failedAmount: string;
      failedCount: string;
    };
    data: Array<{
      __typename: 'ChargesDateRangeKPIRow';
      timestamp: number;
      succeededAmount: string;
      succeededCount: string;
      capturedAmount: string;
      capturedCount: string;
      directAmount: string;
      directCount: string;
      canceledAmount: string;
      canceledCount: string;
      refundedAmount: string;
      refundedCount: string;
      failedAmount: string;
      failedCount: string;
      cuSucceededAmount: string;
      cuSucceededCount: string;
      cuCapturedAmount: string;
      cuCapturedCount: string;
      cuDirectAmount: string;
      cuDirectCount: string;
    }>;
  };
};

export type UserQueryVariables = {
  id: string;
};

export type UserQuery = {
  user?: {
    __typename: 'User';
    id: string;
    email: string;
    status: UserStatus;
    enabled: boolean;
    accountId?: string | null;
    testAccountId?: string | null;
    createdAt: string;
    locale?: string | null;
    referralCode?: string | null;
    promoCode?: string | null;
    emailVerified?: boolean | null;
    phoneNumber?: string | null;
    phoneNumberVerified?: boolean | null;
    smsMfaEnabled?: boolean | null;
  } | null;
};

export type UsersQueryVariables = {
  filter?: string | null;
  token?: string | null;
  limit?: number | null;
};

export type UsersQuery = {
  users: {
    __typename: 'UsersConnection';
    items: Array<{
      __typename: 'User';
      id: string;
      email: string;
      status: UserStatus;
      enabled: boolean;
      accountId?: string | null;
      testAccountId?: string | null;
      createdAt: string;
      locale?: string | null;
      referralCode?: string | null;
      promoCode?: string | null;
      emailVerified?: boolean | null;
      phoneNumber?: string | null;
      phoneNumberVerified?: boolean | null;
      smsMfaEnabled?: boolean | null;
    }>;
    nextToken?: string | null;
  };
};

export type SettlementEventsQueryVariables = {
  settlementId: string;
  size?: number | null;
  from?: number | null;
};

export type SettlementEventsQuery = {
  settlementEvents: {
    __typename: 'SettlementEventsConnection';
    items: Array<{
      __typename: 'SettlementEvent';
      id: string;
      type: string;
      accountId: string;
      objectId: string;
      objectType: string;
      object: {
        __typename: 'SettlementEventObject';
        accountId: string;
        acquirer: SettlementAcquirer;
        acquirerFees: number;
        createdAt: number;
        grossVolume: number;
        iban?: string | null;
        id: string;
        legalName?: string | null;
        netVolume: number;
        period: number;
        payMethod?: SettlementPayMethods | null;
        periodEndAt: number;
        periodStartAt: number;
        previousNegative?: boolean | null;
        releasedAmount?: number | null;
        reservedAmount?: number | null;
        reservePercent: number;
        scheduledAt: number;
        status: SettlementStatus;
        updatedAt: number;
      };
      createdAt: number;
    }>;
    total: number;
  };
};

export type DocumentQueryVariables = {
  id: string;
  accountId: string;
};

export type DocumentQuery = {
  document?: {
    __typename: 'Document';
    id: string;
    accountId: string;
    type: DocumentType;
    status: DocumentStatus;
    statusCode?: string | null;
    statusMessage?: string | null;
    contentType?: string | null;
    createdAt: string;
    updatedAt?: string | null;
    name?: string | null;
    note?: string | null;
    internal?: boolean | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    metadata?: Array<{
      __typename: 'DocumentMetadataItem';
      key: string;
      value?: string | null;
    }> | null;
  } | null;
};

export type DocumentsQueryVariables = {
  token?: string | null;
  pageSize?: number | null;
  accountId: string;
};

export type DocumentsQuery = {
  documents: {
    __typename: 'DocumentsConnection';
    items: Array<{
      __typename: 'Document';
      id: string;
      accountId: string;
      type: DocumentType;
      status: DocumentStatus;
      statusCode?: string | null;
      statusMessage?: string | null;
      contentType?: string | null;
      createdAt: string;
      updatedAt?: string | null;
      name?: string | null;
      note?: string | null;
      internal?: boolean | null;
      traceDetails?: {
        __typename: 'TraceDetails';
        ip?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
        userId?: string | null;
        userEmail?: string | null;
        userName?: string | null;
      } | null;
      metadata?: Array<{
        __typename: 'DocumentMetadataItem';
        key: string;
        value?: string | null;
      }> | null;
    }>;
    nextToken?: string | null;
  };
};

export type DocumentEventsQueryVariables = {
  documentId: string;
};

export type DocumentEventsQuery = {
  documentEvents: {
    __typename: 'DocumentEventsConnection';
    items: Array<{
      __typename: 'DocumentEvent';
      id: string;
      type: string;
      accountId: string;
      objectId: string;
      objectType: string;
      object: {
        __typename: 'DocumentEventObject';
        id: string;
        accountId: string;
        type: DocumentType;
        status: DocumentStatus;
        statusCode?: string | null;
        statusMessage?: string | null;
        contentType?: string | null;
        createdAt: number;
        updatedAt?: number | null;
        name?: string | null;
        note?: string | null;
        internal?: boolean | null;
        traceDetails?: {
          __typename: 'TraceDetails';
          ip?: string | null;
          userAgent?: string | null;
          countryCode?: string | null;
          lang?: string | null;
          deviceType?: DeviceType | null;
          deviceModel?: string | null;
          browser?: string | null;
          browserVersion?: string | null;
          browserAccept?: string | null;
          os?: string | null;
          osVersion?: string | null;
          source?: string | null;
          sourceVersion?: string | null;
          userId?: string | null;
          userEmail?: string | null;
          userName?: string | null;
        } | null;
        metadata?: Array<{
          __typename: 'DocumentMetadataItem';
          key: string;
          value?: string | null;
        }> | null;
      };
      createdAt: number;
    }>;
    total: number;
  };
};

export type SettlementsEventsQueryVariables = {
  filter?: SearchableSettlementEventFilterInput | null;
  size?: number | null;
  from?: number | null;
};

export type SettlementsEventsQuery = {
  settlementsEvents: {
    __typename: 'SettlementEventsConnection';
    items: Array<{
      __typename: 'SettlementEvent';
      id: string;
      type: string;
      accountId: string;
      objectId: string;
      objectType: string;
      object: {
        __typename: 'SettlementEventObject';
        accountId: string;
        acquirer: SettlementAcquirer;
        acquirerFees: number;
        createdAt: number;
        grossVolume: number;
        iban?: string | null;
        id: string;
        legalName?: string | null;
        netVolume: number;
        period: number;
        payMethod?: SettlementPayMethods | null;
        periodEndAt: number;
        periodStartAt: number;
        previousNegative?: boolean | null;
        releasedAmount?: number | null;
        reservedAmount?: number | null;
        reservePercent: number;
        scheduledAt: number;
        status: SettlementStatus;
        updatedAt: number;
      };
      createdAt: number;
    }>;
    total: number;
  };
};

export type SettlementsQueryVariables = {
  filter?: SearchableSettlementFilterInput | null;
  size?: number | null;
  from?: number | null;
};

export type SettlementsQuery = {
  settlements: {
    __typename: 'SettlementsConnection';
    items: Array<{
      __typename: 'Settlement';
      accountId: string;
      acquirer: SettlementAcquirer;
      acquirerFees: number;
      createdAt: number;
      grossVolume: number;
      iban?: string | null;
      id: string;
      legalName?: string | null;
      netVolume: number;
      payMethod?: SettlementPayMethods | null;
      period: number;
      periodEndAt: number;
      periodStartAt: number;
      previousNegative?: boolean | null;
      releasedAmount?: number | null;
      reservedAmount?: number | null;
      reservePercent: number;
      scheduledAt: number;
      status: SettlementStatus;
      updatedAt: number;
    }>;
    total: number;
  };
};

export type InvoicesQueryVariables = {
  filter?: SearchableInvoiceFilterInput | null;
  size?: number | null;
  from?: number | null;
};

export type InvoicesQuery = {
  invoices: {
    __typename: 'InvoicesConnection';
    items: Array<{
      __typename: 'AccountInvoice';
      accountId: string;
      period: {
        __typename: 'AccountInvoicePeriod';
        from?: number | null;
        to?: number | null;
      };
      currency: string;
      amount: number;
      tax: number;
      number: string;
      totalAmount: number;
      lineItems: Array<{
        __typename: 'AccountInvoiceLineItem';
        name: string;
        quantity: number;
        unitAmount: number;
        unitType: InvoiceLineItemUnitType;
        currency: string;
        amount: number;
      }>;
      createdAt: number;
      business?: {
        __typename: 'InvoiceBusinessData';
        legalName?: string | null;
        iban?: string | null;
        documentNumber?: string | null;
        mandateSignatureTimestamp?: string | null;
      } | null;
    }>;
    total: number;
  };
};

export type AuthorizedUsersQueryVariables = {
  accountId: string;
};

export type AuthorizedUsersQuery = {
  authorizedUsers: {
    __typename: 'AuthorizedUsersConnection';
    items: Array<{
      __typename: 'AuthorizedUser';
      accountId?: string | null;
      userEmail: string;
      id?: string | null;
      accessLevel: AuthorizedUserAccessLevel;
      storeId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    }>;
  };
};

export type PaymentEmailPreviewQueryVariables = {
  paymentId: string;
  emailType?: PaymentEmailType | null;
  language?: string | null;
  accountId: string;
};

export type PaymentEmailPreviewQuery = {
  paymentEmailPreview?: string | null;
};

export type MasterAccountsQuery = {
  masterAccounts: {
    __typename: 'MasterAccountsConnection';
    items: Array<{
      __typename: 'MasterAccount';
      id: string;
      adminEmail?: string | null;
      apiKey?: string | null;
      business?: {
        __typename: 'BusinessData';
        country?: string | null;
        legalForm?: LegalForm | null;
        legalName?: string | null;
        companyName?: string | null;
        address?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        documentNumber?: string | null;
        email?: string | null;
        phone?: string | null;
        website?: string | null;
        monthlyVolume?: number | null;
        confirmWebsite?: boolean | null;
        industry?: Industries | null;
        mcc?: string | null;
        servicesDescription?: string | null;
        status?: BusinessStatus | null;
        confirmServicesDescription?: boolean | null;
        legalAddress?: string | null;
        legalDescription?: string | null;
        creationDate?: string | null;
        lastUpdateDate?: string | null;
        startActivityDate?: string | null;
        registryRecords?: Array<{
          __typename: 'RegistryRecord';
          name?: string | null;
          url?: string | null;
          province?: string | null;
          date?: string | null;
        }> | null;
        positions?: Array<{
          __typename: 'BusinessPosition';
          fromDate?: string | null;
          role?: string | null;
          name?: string | null;
        }> | null;
        capital?: string | null;
        previousNames?: Array<string | null> | null;
        verificationAttempts?: number | null;
        riskLabels?: Array<{
          __typename: 'RiskLabel';
          label?: string | null;
          category?: string | null;
        }> | null;
      } | null;
      contractTemplateId?: string | null;
      createdAt?: string | null;
      deletedAt?: string | null;
      extraFees?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      } | null> | null;
      iban?: string | null;
      name?: string | null;
      payoutTerms?: {
        __typename: 'AccountPayoutTerms';
        iban?: string | null;
        firstPeriod?: number | null;
        period?: number | null;
        reservePercent?: number | null;
        suspended?: boolean | null;
        releaseReserve?: boolean | null;
      } | null;
      promoCode?: string | null;
      status?: AccountStatus | null;
      traceDetails?: {
        __typename: 'TraceDetails';
        ip?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
        userId?: string | null;
        userEmail?: string | null;
        userName?: string | null;
      } | null;
      updatedAt?: string | null;
      allowedIPs?: Array<string | null> | null;
      accountDefaults?: {
        __typename: 'AccountDefaults';
        billingPlan?: BillingPlans | null;
        iban?: string | null;
        payoutTerms?: {
          __typename: 'AccountPayoutTerms';
          iban?: string | null;
          firstPeriod?: number | null;
          period?: number | null;
          reservePercent?: number | null;
          suspended?: boolean | null;
          releaseReserve?: boolean | null;
        } | null;
        fees?: {
          __typename: 'AccountFees';
          trxFee?: number | null;
          trxFlatFee?: number | null;
          highRiskFee?: number | null;
          dailyPlatformFee?: number | null;
          dailyExtraSeatsFee?: number | null;
          extra?: Array<{
            __typename: 'AccountExtraFee';
            name: string;
            amount: number;
            type: AccountExtraFeeType;
            region?: AccountExtraFeeRegion | null;
            masterAccountFee?: boolean | null;
          }> | null;
          steps?: Array<{
            __typename: 'AccountSteps';
            from: number;
            trxFee: number;
            trxFlatFee: number;
            bizumTrxFee?: number | null;
            bizumTrxFlatFee?: number | null;
            multibancoTrxFee?: number | null;
            multibancoTrxFlatFee?: number | null;
          }> | null;
        } | null;
        business?: {
          __typename: 'BusinessDefault';
          mcc?: string | null;
          website?: string | null;
          confirmWebsite?: boolean | null;
          servicesDescription?: string | null;
          confirmServicesDescription?: boolean | null;
        } | null;
        language?: string | null;
        notifications?: {
          __typename: 'AccountNotifications';
          emailCustomerOnRefund?: boolean | null;
          emailCustomerOnSuccess?: boolean | null;
          emailAdminOnSuccess?: boolean | null;
        } | null;
      } | null;
    }>;
  };
};

export type MasterAccountQueryVariables = {
  id: string;
};

export type MasterAccountQuery = {
  masterAccount: {
    __typename: 'MasterAccountsConnection';
    items: Array<{
      __typename: 'MasterAccount';
      id: string;
      adminEmail?: string | null;
      apiKey?: string | null;
      business?: {
        __typename: 'BusinessData';
        country?: string | null;
        legalForm?: LegalForm | null;
        legalName?: string | null;
        companyName?: string | null;
        address?: {
          __typename: 'Address';
          city?: string | null;
          country?: string | null;
          line1?: string | null;
          line2?: string | null;
          zip?: string | null;
          state?: string | null;
        } | null;
        documentNumber?: string | null;
        email?: string | null;
        phone?: string | null;
        website?: string | null;
        monthlyVolume?: number | null;
        confirmWebsite?: boolean | null;
        industry?: Industries | null;
        mcc?: string | null;
        servicesDescription?: string | null;
        status?: BusinessStatus | null;
        confirmServicesDescription?: boolean | null;
        legalAddress?: string | null;
        legalDescription?: string | null;
        creationDate?: string | null;
        lastUpdateDate?: string | null;
        startActivityDate?: string | null;
        registryRecords?: Array<{
          __typename: 'RegistryRecord';
          name?: string | null;
          url?: string | null;
          province?: string | null;
          date?: string | null;
        }> | null;
        positions?: Array<{
          __typename: 'BusinessPosition';
          fromDate?: string | null;
          role?: string | null;
          name?: string | null;
        }> | null;
        capital?: string | null;
        previousNames?: Array<string | null> | null;
        verificationAttempts?: number | null;
        riskLabels?: Array<{
          __typename: 'RiskLabel';
          label?: string | null;
          category?: string | null;
        }> | null;
      } | null;
      contractTemplateId?: string | null;
      createdAt?: string | null;
      deletedAt?: string | null;
      extraFees?: Array<{
        __typename: 'AccountExtraFee';
        name: string;
        amount: number;
        type: AccountExtraFeeType;
        region?: AccountExtraFeeRegion | null;
        masterAccountFee?: boolean | null;
      } | null> | null;
      iban?: string | null;
      name?: string | null;
      payoutTerms?: {
        __typename: 'AccountPayoutTerms';
        iban?: string | null;
        firstPeriod?: number | null;
        period?: number | null;
        reservePercent?: number | null;
        suspended?: boolean | null;
        releaseReserve?: boolean | null;
      } | null;
      promoCode?: string | null;
      status?: AccountStatus | null;
      traceDetails?: {
        __typename: 'TraceDetails';
        ip?: string | null;
        userAgent?: string | null;
        countryCode?: string | null;
        lang?: string | null;
        deviceType?: DeviceType | null;
        deviceModel?: string | null;
        browser?: string | null;
        browserVersion?: string | null;
        browserAccept?: string | null;
        os?: string | null;
        osVersion?: string | null;
        source?: string | null;
        sourceVersion?: string | null;
        userId?: string | null;
        userEmail?: string | null;
        userName?: string | null;
      } | null;
      updatedAt?: string | null;
      allowedIPs?: Array<string | null> | null;
      accountDefaults?: {
        __typename: 'AccountDefaults';
        billingPlan?: BillingPlans | null;
        iban?: string | null;
        payoutTerms?: {
          __typename: 'AccountPayoutTerms';
          iban?: string | null;
          firstPeriod?: number | null;
          period?: number | null;
          reservePercent?: number | null;
          suspended?: boolean | null;
          releaseReserve?: boolean | null;
        } | null;
        fees?: {
          __typename: 'AccountFees';
          trxFee?: number | null;
          trxFlatFee?: number | null;
          highRiskFee?: number | null;
          dailyPlatformFee?: number | null;
          dailyExtraSeatsFee?: number | null;
          extra?: Array<{
            __typename: 'AccountExtraFee';
            name: string;
            amount: number;
            type: AccountExtraFeeType;
            region?: AccountExtraFeeRegion | null;
            masterAccountFee?: boolean | null;
          }> | null;
          steps?: Array<{
            __typename: 'AccountSteps';
            from: number;
            trxFee: number;
            trxFlatFee: number;
            bizumTrxFee?: number | null;
            bizumTrxFlatFee?: number | null;
            multibancoTrxFee?: number | null;
            multibancoTrxFlatFee?: number | null;
          }> | null;
        } | null;
        business?: {
          __typename: 'BusinessDefault';
          mcc?: string | null;
          website?: string | null;
          confirmWebsite?: boolean | null;
          servicesDescription?: string | null;
          confirmServicesDescription?: boolean | null;
        } | null;
        language?: string | null;
        notifications?: {
          __typename: 'AccountNotifications';
          emailCustomerOnRefund?: boolean | null;
          emailCustomerOnSuccess?: boolean | null;
          emailAdminOnSuccess?: boolean | null;
        } | null;
      } | null;
    }>;
  };
};

export type UserMasterAccountQuery = {
  userMasterAccount?: {
    __typename: 'MasterAccount';
    id: string;
    adminEmail?: string | null;
    apiKey?: string | null;
    business?: {
      __typename: 'BusinessData';
      country?: string | null;
      legalForm?: LegalForm | null;
      legalName?: string | null;
      companyName?: string | null;
      address?: {
        __typename: 'Address';
        city?: string | null;
        country?: string | null;
        line1?: string | null;
        line2?: string | null;
        zip?: string | null;
        state?: string | null;
      } | null;
      documentNumber?: string | null;
      email?: string | null;
      phone?: string | null;
      website?: string | null;
      monthlyVolume?: number | null;
      confirmWebsite?: boolean | null;
      industry?: Industries | null;
      mcc?: string | null;
      servicesDescription?: string | null;
      status?: BusinessStatus | null;
      confirmServicesDescription?: boolean | null;
      legalAddress?: string | null;
      legalDescription?: string | null;
      creationDate?: string | null;
      lastUpdateDate?: string | null;
      startActivityDate?: string | null;
      registryRecords?: Array<{
        __typename: 'RegistryRecord';
        name?: string | null;
        url?: string | null;
        province?: string | null;
        date?: string | null;
      }> | null;
      positions?: Array<{
        __typename: 'BusinessPosition';
        fromDate?: string | null;
        role?: string | null;
        name?: string | null;
      }> | null;
      capital?: string | null;
      previousNames?: Array<string | null> | null;
      verificationAttempts?: number | null;
      riskLabels?: Array<{
        __typename: 'RiskLabel';
        label?: string | null;
        category?: string | null;
      }> | null;
    } | null;
    contractTemplateId?: string | null;
    createdAt?: string | null;
    deletedAt?: string | null;
    extraFees?: Array<{
      __typename: 'AccountExtraFee';
      name: string;
      amount: number;
      type: AccountExtraFeeType;
      region?: AccountExtraFeeRegion | null;
      masterAccountFee?: boolean | null;
    } | null> | null;
    iban?: string | null;
    name?: string | null;
    payoutTerms?: {
      __typename: 'AccountPayoutTerms';
      iban?: string | null;
      firstPeriod?: number | null;
      period?: number | null;
      reservePercent?: number | null;
      suspended?: boolean | null;
      releaseReserve?: boolean | null;
    } | null;
    promoCode?: string | null;
    status?: AccountStatus | null;
    traceDetails?: {
      __typename: 'TraceDetails';
      ip?: string | null;
      userAgent?: string | null;
      countryCode?: string | null;
      lang?: string | null;
      deviceType?: DeviceType | null;
      deviceModel?: string | null;
      browser?: string | null;
      browserVersion?: string | null;
      browserAccept?: string | null;
      os?: string | null;
      osVersion?: string | null;
      source?: string | null;
      sourceVersion?: string | null;
      userId?: string | null;
      userEmail?: string | null;
      userName?: string | null;
    } | null;
    updatedAt?: string | null;
    allowedIPs?: Array<string | null> | null;
    accountDefaults?: {
      __typename: 'AccountDefaults';
      billingPlan?: BillingPlans | null;
      iban?: string | null;
      payoutTerms?: {
        __typename: 'AccountPayoutTerms';
        iban?: string | null;
        firstPeriod?: number | null;
        period?: number | null;
        reservePercent?: number | null;
        suspended?: boolean | null;
        releaseReserve?: boolean | null;
      } | null;
      fees?: {
        __typename: 'AccountFees';
        trxFee?: number | null;
        trxFlatFee?: number | null;
        highRiskFee?: number | null;
        dailyPlatformFee?: number | null;
        dailyExtraSeatsFee?: number | null;
        extra?: Array<{
          __typename: 'AccountExtraFee';
          name: string;
          amount: number;
          type: AccountExtraFeeType;
          region?: AccountExtraFeeRegion | null;
          masterAccountFee?: boolean | null;
        }> | null;
        steps?: Array<{
          __typename: 'AccountSteps';
          from: number;
          trxFee: number;
          trxFlatFee: number;
          bizumTrxFee?: number | null;
          bizumTrxFlatFee?: number | null;
          multibancoTrxFee?: number | null;
          multibancoTrxFlatFee?: number | null;
        }> | null;
      } | null;
      business?: {
        __typename: 'BusinessDefault';
        mcc?: string | null;
        website?: string | null;
        confirmWebsite?: boolean | null;
        servicesDescription?: string | null;
        confirmServicesDescription?: boolean | null;
      } | null;
      language?: string | null;
      notifications?: {
        __typename: 'AccountNotifications';
        emailCustomerOnRefund?: boolean | null;
        emailCustomerOnSuccess?: boolean | null;
        emailAdminOnSuccess?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type OnUpdateAnalyticsSubscriptionVariables = {
  all: boolean;
};

export type OnUpdateAnalyticsSubscription = {
  onUpdateAnalytics?: {
    __typename: 'AnalyticsChange';
    all?: boolean | null;
  } | null;
};

export type OnUpdateEventsSubscriptionVariables = {
  accountId: string;
};

export type OnUpdateEventsSubscription = {
  onUpdateEvents?: {
    __typename: 'EventsChange';
    accountId?: string | null;
  } | null;
};

export type OnUpdateDocumentsSubscriptionVariables = {
  accountId: string;
};

export type OnUpdateDocumentsSubscription = {
  onUpdateDocuments?: {
    __typename: 'DocumentsChange';
    accountId?: string | null;
  } | null;
};
